<template>
 <div class="responsive-container">
    <el-container class="responsive-content">
      <div class="bbb2">

        <div class="custom-tabs-container" >
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <!--          <el-tab-pane label="投放数据" name="first" ></el-tab-pane>-->

            <el-tab-pane label="投放营收数据" name="third"></el-tab-pane>
            <el-tab-pane label="预估倍率" name="4"></el-tab-pane>
            <!--            <el-tab-pane label="投放个人" name="5"></el-tab-pane>-->
            <div class="chart-container" v-show="activeName==='4'&&showChart===true">
              <el-select
                  size="mini"
                  class="el-select2"
                  v-model="selectedDays"
                  multiple
                  placeholder="请选择要展示的天数"
                  @change="updateChart"
              >
                <el-option
                    v-for="day in roiDays"
                    :key="day"
                    :label="`${day}日数据`"
                    :value="day"
                />
              </el-select>
              <el-checkbox
                  v-model="showCost"
                  @change="updateChart"
              >显示消耗
              </el-checkbox>

              <el-checkbox
                  v-model="showCost2"
                  @change="updateChart"
              >显示实际消耗
              </el-checkbox>

              <el-checkbox
                  v-model="showCost3"
                  @change="updateChart"
              >显示利润
              </el-checkbox>

              <!-- 新增复选框：控制图表中的 ROI 和倍率显示 -->
              <el-checkbox
                  v-model="showChartROI"
                  @change="updateChart"
                  v-show="activeName==='4'"    style="margin-left: 16px;height: 30px;margin-top:12px;">
                显示图表ROI
              </el-checkbox>

              <el-checkbox
                  v-model="showChartRate"
                  @change="updateChart"
                  v-show="activeName==='4'"    style="margin-left: 16px;height: 30px;margin-top:12px;">
                显示图表倍率
              </el-checkbox>
              <div ref="chart" class="responsive-chart"></div>

            </div>
            <el-header class="responsive-header">
              <span class="style-title">项目名称:</span>
              <el-select v-model="valueGame" placeholder="游戏选择" size="mini" @change="changeGame()"
                         style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                         filterable clearable>
                <el-option
                    v-for="item in optionsGame"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>

              <span class="style-title">日期:</span>

              <el-date-picker
                  v-model="value2"
                  type="daterange"
                  align="right"
                  unlink-panels
                  style="margin-left: 5px;margin-top: 9px;height:28px;width: 280px;align-items: center;display: flex"
                  size="mini"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions3">
              </el-date-picker>


              <el-select v-model="gameType" placeholder="品类选择" size="mini" v-if="activeName==='4'"

                         style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex;width: 110px"
                         filterable clearable>
                <el-option

                    v-for="item in uniqueGameTypes"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>


              <el-button size="mini"
                         style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                         @click="search(true)" icon="el-icon-refresh">
                刷新
              </el-button>


              <el-checkbox-group
                  class="style-title"
                  v-show="activeName!=='4'"
                  v-model="checkedCities"
                  :min="1"
                  :max="3">
                <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
              </el-checkbox-group>


              <el-checkbox-group
                  v-show="activeName==='4'"
                  v-model="checkedYugu"
                  style="display: flex; align-items: center; height: 30px; margin-left: 15px;margin-top: 5px ; flex-wrap: wrap;"
              >
                <el-checkbox
                    v-for="item in citiesYugu"
                    :key="item"
                    :label="item" style="margin-right: 15px; background: rgba(64, 158, 255, 0.1);
             border: 1px solid rgba(64, 158, 255, 0.3);
             border-radius: 15px; padding: 4px 12px;
             transition: all 0.3s ease;
             font-size: 12px;
             color: #606266;">
                  <span style="font-weight: 500;">{{ item }}</span>
                </el-checkbox>
              </el-checkbox-group>

              <el-button size="mini"
                         style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                         v-show="activeName!=='4'"
                         @click="dialogFormVisible=true;get()" icon="el-icon-s-tools">
                设置比例
              </el-button>


              <el-button size="mini"
                         type="warning"
                         style="margin-left: 6px;height: 30px;margin-top:8px;"
                         v-show="activeName!=='4'"
                         @click="openBackfillDialog" icon="el-icon-refresh-left">
                补发数据
              </el-button>

              <el-button size="mini"
                         style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #ecf5ff;color: #409EFF"
                         v-show="activeName!=='4'"
                         @click="openLiveGameDialog" icon="el-icon-video-camera">
                直播游戏
              </el-button>

              <el-checkbox-group
                  style="margin-left: 5px; display: flex; align-items: center; height: 30px;"
                  class="style-title"
                  v-show="activeName==='4'"
                  v-model="checkedCities2"
                  :min="1"
                  :max="3">
                <template v-for="city in cities2">
                  <el-checkbox
                      :key="city"
                      :label="city"
                      style="margin-right: 15px; background: rgba(64, 158, 255, 0.1);

               border: 1px solid rgba(64, 158, 255, 0.3);
               border-radius: 15px; padding: 4px 12px;
               transition: all 0.3s ease;
               font-size: 12px;
               color: #606266;">
                    <span style="font-weight: 500;">{{ city }}</span>
                  </el-checkbox>
                </template>
              </el-checkbox-group>

              <download-excel style="margin-top: 10px;width: 150px;margin-left: 10px" :data="json_data"
                              :fields="json_fields"
                              v-show="activeName==='third'"
                              name="营收.xls" :fetch="createExportData">
                <el-button type="danger" size="mini">导出Excel</el-button>
              </download-excel>

              <el-button
                  v-show="activeName==='4'"
                  type="danger"
                  size="mini"
                  style="margin-top: 10px;margin-left: 10px"
                  :disabled="loading || !tableDataY4 || tableDataY4.length === 0"
                  @click="exportY4PredictionTable">
                导出Excel
              </el-button>

              <!--          <download-excel style="margin-top: 10px;width: 150px;margin-left: 10px" :data="json_data2"-->
              <!--                          :fields="json_fields2"-->
              <!--                          v-show="activeName==='second'"-->
              <!--                          name="投放数据.xls" :fetch="createExportData2">-->

              <!--            <el-button type="danger" size="mini">导出Excel</el-button>-->
              <!--          </download-excel>-->
              <el-dialog title="设置分成比例" :visible.sync="dialogFormVisible">
                <el-form :model="form" :label-width="formLabelWidth" style="margin-right: 60px">


                  <el-form-item label="日期:" :rules="[{ required: true, message: '年龄不能为空'}, ]">

                    <el-date-picker
                        v-model="form.date"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions3">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="属性:" :rules="[{ required: true, message: '年龄不能为空'}, ]">

                    <el-select v-model="form.type" filterable placeholder="请选择" clearable allow-create @change="get">
                      <el-option
                          v-for="item in options3"
                          :key="item"
                          :label="item"
                          :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="分成比例:" :rules="[{ required: true, message: '年龄不能为空'}, ]">
                    <el-input-number v-model="form.divisionScale" autocomplete="off" :precision="3" :step="0.001"
                                     :max="100"></el-input-number>
                  </el-form-item>

                  <el-form-item label="所有游戏:" :rules="[{ required: true, message: '年龄不能为空'}, ]">
                    <el-checkbox v-model="form.checked">是</el-checkbox>
                  </el-form-item>


                  <el-form-item label="默认分成比例:" :rules="[{ required: true, message: '年龄不能为空'}, ]">
                    <el-input-number v-model="form.allDivisionScale" autocomplete="off" :precision="3" :step="0.001"
                                     @change="change()"
                                     :max="100"></el-input-number>
                    <span style="font-size: 10px;color: #d65055">注:每日按默认设置,更改后及更新,无需确认</span>
                  </el-form-item>

                </el-form>


                <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="edit">确 定</el-button>
                </div>
              </el-dialog>

              <el-dialog title="补发历史数据" :visible.sync="backfillDialogVisible" width="560px">
                <el-form :model="backfillForm" label-width="110px">
                  <el-form-item label="日期">
                    <el-date-picker
                        v-model="backfillForm.date"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="游戏">
                    <el-select
                        v-model="backfillForm.gameNames"
                        multiple
                        filterable
                        clearable
                        collapse-tags
                        placeholder="不选则补全部游戏"
                        style="width: 100%;">
                      <el-option
                          v-for="item in optionsGame"
                          :key="item"
                          :label="item"
                          :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="补发内容">
                    <el-checkbox v-model="backfillForm.includeFlowIncome">流量主收入</el-checkbox>
                    <el-checkbox v-model="backfillForm.includeCashCost">现金消耗</el-checkbox>
                    <el-checkbox v-model="backfillForm.includeRoi">ROI</el-checkbox>
                    <el-checkbox v-model="backfillForm.includeToufang">投放明细(toufang_data_dy)</el-checkbox>
                  </el-form-item>
                  <div class="backfill-tip">
                    提交后由后台异步抓取并写库，完成时间取决于日期范围和游戏数量。日期范围最多 31 天；投放明细会按账号抓取，不按游戏过滤。
                  </div>
                  <div v-if="backfillTask" class="backfill-status">
                    <el-alert
                        :title="backfillTaskTitle"
                        :type="backfillTaskAlertType"
                        :closable="false"
                        show-icon>
                      <div class="backfill-status-body">
                        <div>任务号：{{ backfillTask.taskId }}，状态：{{ backfillTask.status }}，{{ backfillTask.message || '-' }}</div>
                        <div v-if="backfillTask.result">
                          进度：{{ backfillTask.result.finished || 0 }}/{{ backfillTask.result.total || 0 }}，
                          成功：{{ backfillTask.result.success || 0 }}，
                          失败：{{ backfillTask.result.failed || 0 }}
                        </div>
                        <div v-if="backfillTask.updatedAt">最后更新：{{ backfillTask.updatedAt }}</div>
                        <div v-if="backfillTask.result && backfillTask.result.errors && backfillTask.result.errors.length">
                          <div class="backfill-error-title">失败原因：</div>
                          <div
                              v-for="(item, index) in backfillTask.result.errors"
                              :key="index"
                              class="backfill-error-line">
                            {{ item.date }} {{ item.gameName }} {{ item.action }}：{{ item.message }}
                          </div>
                        </div>
                      </div>
                    </el-alert>
                  </div>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="backfillDialogVisible = false">取 消</el-button>
                  <el-button type="primary" :loading="backfillLoading" @click="submitBackfill">提交补发</el-button>
                </div>
              </el-dialog>

              <el-dialog title="直播游戏配置" :visible.sync="liveGameDialogVisible" width="720px">
                <el-alert
                    title="配置为直播游戏后，巨量账号快照定时同步到 x_cost_cash 时会跳过这些游戏，不再写入现金消耗和账面消耗。"
                    type="info"
                    :closable="false"
                    show-icon
                    style="margin-bottom: 14px;">
                </el-alert>
                <el-form :inline="true" :model="liveGameForm" size="small">
                  <el-form-item label="游戏">
                    <el-select
                        v-model="liveGameForm.gameName"
                        filterable
                        clearable
                        allow-create
                        default-first-option
                        placeholder="选择或输入游戏名"
                        style="width: 260px;">
                      <el-option
                          v-for="item in optionsGame"
                          :key="item"
                          :label="item"
                          :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="备注">
                    <el-input
                        v-model="liveGameForm.remark"
                        clearable
                        placeholder="可选"
                        style="width: 220px;">
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" :loading="liveGameSaving" @click="saveLiveGameConfig">保存</el-button>
                  </el-form-item>
                </el-form>
                <el-table
                    v-loading="liveGameLoading"
                    :data="liveGameList"
                    border
                    size="small"
                    height="320px">
                  <el-table-column prop="game_name" label="游戏名称" min-width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="normalized_game_name" label="匹配名称" min-width="160" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
                  <el-table-column label="状态" width="100">
                    <template slot-scope="{ row }">
                      <el-switch
                          :value="Number(row.enabled) === 1"
                          active-text="启用"
                          inactive-text="停用"
                          @change="toggleLiveGame(row, $event)">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="updated_at" label="更新时间" width="170" :formatter="formatLiveGameTime"></el-table-column>
                  <el-table-column label="操作" width="90" fixed="right">
                    <template slot-scope="{ row }">
                      <el-button type="text" size="small" @click="deleteLiveGameConfig(row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="liveGameDialogVisible = false">关 闭</el-button>
                </div>
              </el-dialog>

              <el-checkbox
                  v-model="showChart"
                  v-show="activeName==='4'"
                  style="margin-left: 16px;height: 30px;margin-top:12px;"
              >显示图表
              </el-checkbox>
              <!-- 替换原有的 el-checkbox-group 为以下代码 -->
              <!-- 替换原有的 el-dropdown 为以下代码 -->
              <el-popover
                  v-show="activeName==='4'"
                  placement="bottom"
                  trigger="click" style="margin-left: 20px; margin-top: 8px;"
              >
                <div style="width: 220px; padding: 10px 0;">
                  <div style="font-size: 14px; font-weight: 600; margin-bottom: 12px; color: #303133; padding: 0 12px;">
                    <i class="el-icon-setting" style="margin-right: 8px; color: #409EFF;"></i>列设置
                  </div>
                  <el-checkbox-group
                      v-model="visibleColumns"
                      style="display: flex; flex-direction: column; gap: 10px; max-height: 300px; overflow-y: auto;"
                  >
                    <el-checkbox
                        v-for="col in columnOptions"
                        :key="col.value"
                        :label="col.value" style="margin: 0; padding: 6px 12px; border-radius: 4px;"
                    >
                      <span style="font-size: 13px;">{{ col.label }}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                  <div style="display: flex; justify-content: flex-end; margin-top: 12px; padding: 0 12px;">
                    <el-button
                        type="primary"
                        size="mini"
                        @click="resetColumns" style="background: linear-gradient(90deg, #409EFF, #1a7cff); border: none;"
                    >
                      重置
                    </el-button>
                  </div>
                </div>
                <el-button
                    slot="reference"
                    size="mini"
                    style="background: linear-gradient(90deg, #f5f7fa, #e4e7ed); border: 1px solid #dcdfe6; border-radius: 4px;"
                >
                  <i class="el-icon-setting"></i> 列设置
                </el-button>
              </el-popover>

            </el-header>


            <el-table
                ref="tableData1"
                v-show="activeName==='first'"
                :data="tableData"
                stripe
                border
                :height="tableHeight"
                style="margin-top: 11px;"
                :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
                size="mini"
                v-loading="loading"
                highlight-current-row

            >

              <el-table-column
                  align="center"
                  type="selection"
                  width="44">
              </el-table-column>

              <el-table-column
                  prop="cDate"
                  label="日期"
                  sortable
                  min-width="100"

                  v-if="checkedCities.indexOf('日期')>-1"
              >

              </el-table-column>

              <el-table-column
                  prop="aname"
                  label="游戏名称"
                  min-width="180"

                  v-if="checkedCities.indexOf('游戏名')>-1"
              >
              </el-table-column>

              <el-table-column
                  prop="cAmount"
                  label="实际消耗"
                  min-width="160"
                  sortable
                  :formatter="value_format"
              >
                <template slot="header">
                  <span>实际消耗(元)</span>
                  <el-tooltip>

                    <i class="el-icon-info" style="color: #3a8ee6;width: 10px"></i>

                    <div slot="content">
                      <div>扣除赔付</div>
                    </div>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">

                  {{ (scope.row.cAmount - scope.row.bfUv) / 100|dataFilters }}
                </template>
              </el-table-column>

              <el-table-column
                  prop="sum"
                  label="实时ROI(含实际赔付)"
                  min-width="160"

              >
                <template slot-scope="scope">
              <span v-if="scope.row.cDate==='合计'">{{
                  ((scope.row.sum / (scope.row.cAmount - scope.row.bfUv)) * 10000).toFixed(2) + '%'
                }} <span style="color: #2E95FB;font-family: 微软雅黑,serif;font-size: 11px">{{
                    isNaN(scope.row.sum) ? '' : '(' + ((scope.row.sum / (scope.row.cAmount - scope.row.bfUv) * 10000) - (scope.row.sum / (scope.row.cAmount) * 10000)).toFixed(2) + '%)'
                  }}</span>
            </span>
                  <span v-else> {{
                      isNaN(((scope.row.sum / (scope.row.cAmount - scope.row.bfUv)) * 10000)) ? 0 : ((scope.row.sum / (scope.row.cAmount - scope.row.bfUv) * 10000)).toFixed(2) + '%'
                    }}

                <span style="color: #2E95FB;font-family: 微软雅黑,serif;font-size: 11px">{{
                    isNaN(scope.row.sum) ? '' : '(' + ((scope.row.sum / (scope.row.cAmount - scope.row.bfUv) * 10000) - (scope.row.sum / (scope.row.cAmount) * 10000)).toFixed(2) + '%)'
                  }}
                </span>
              </span>

                </template>
              </el-table-column>

              <el-table-column
                  :v-show="(checkedCities.length===2)"
                  v-for="(item, index) in items"
                  :prop="'f_'+item"
                  :key="index+''"
                  :label="item+'日倍率'"
                  width="110"
                  :formatter="value_format4"
              >

              </el-table-column>
              <el-table-column
                  prop="data.day0"
                  label="首日ROI(含实际赔付)"
                  min-width="180"
              >
                <template slot-scope="scope">{{
                    isNaN(scope.row.data6.day0) ? 0 + '%' : (scope.row.data6.day0 / (scope.row.cAmount - scope.row.bfUv) * 10000).toFixed(2) + '%'
                  }}
                  <span style="color: #2E95FB;font-family: 微软雅黑,serif;font-size: 11px">{{
                      isNaN(scope.row.data6.day0) ? '' : '(' + ((scope.row.data6.day0 / (scope.row.cAmount - scope.row.bfUv) * 10000) - (scope.row.data6.day0 / (scope.row.cAmount) * 10000)).toFixed(2) + '%)'
                    }}</span>
                </template>
              </el-table-column>

              <el-table-column
                  prop="cAmount"
                  label="实时倍率"
                  min-width="160"
              >
                <template slot-scope="scope">

              <span> {{
                  isNaN(scope.row.sum * 10000 / (scope.row.data.day0 * scope.row.cAmount)) ? 0 : (scope.row.sum * 10000 / (scope.row.data.day0 * scope.row.cAmount)).toFixed(2)
                }}</span>

                </template>
              </el-table-column>

              <el-table-column
                  prop=""
                  label="预估终身倍率"
                  min-width="160"
              >

              </el-table-column>
            </el-table>

            <!--   投放营收-->
            <el-table
                ref="tableData1"
                v-show="activeName==='third'"
                :data="pagedIncomeTableData"
                stripe
                border
                :height="tableHeight"
                style="margin-top: 11px;"
                :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
                size="mini"
                v-loading="loading"
                highlight-current-row
                @sort-change="handleIncomeSortChange"

            >

              <el-table-column
                  align="center"
                  type="selection"
                  width="44">
              </el-table-column>

              <el-table-column>

                <el-table-column
                    prop="c_date"
                    label="日期"
                    sortable="custom"
                    min-width="100"
                    label-class-name="table-header"
                    v-if="checkedCities.indexOf('日期')>-1"
                >

                </el-table-column>

                <el-table-column
                    prop="c_name"
                    label="游戏名称"
                    min-width="180"
                    label-class-name="table-header"
                    v-if="checkedCities.indexOf('游戏名')>-1"
                >
                </el-table-column>

                <el-table-column
                    prop="profit"
                    label="利润(元)"
                    min-width="160"

                    sortable="custom"
                    :formatter="value_format"
                    label-class-name="table-header"
                    class-name="table-number"
                >

                  <template slot-scope="{row}">

                <span style="color: #d65055" class="table-number"
                      v-if="row.profit>0">{{
                    row.profit |dataFilters
                  }}
</span>
                    <span v-else class="table-number"
                          style="color: #5daf34">{{
                        row.profit|dataFilters
                      }}
</span>
                  </template>

                </el-table-column>
              </el-table-column>
              <el-table-column align="center" label="支出" label-class-name="table-header">
                <el-table-column
                    prop="c_amount"
                    label="账面消耗(元)"
                    min-width="160"
                    sortable="custom"
                    :sort-method="sortByIncomeNumber('c_amount')"
                    :formatter="value_format2"
                    label-class-name="table-header"
                    class-name="table-number"
                >

                </el-table-column>
                <el-table-column
                    prop="sum_cost_cash"
                    label="现金消耗(元)"
                    min-width="160"
                    sortable="custom"
                    :sort-method="sortByIncomeNumber('sum_cost_cash')"
                    :formatter="value_format2"
                    label-class-name="table-header"
                    class-name="table-number"
                >

                </el-table-column>
              </el-table-column>
              <el-table-column align="center" label="收入" label-class-name="table-header">
                <el-table-column
                    prop="f1"
                    label="流量主收入(元)分成后"
                    min-width="160"
                    :formatter="value_format2"
                    label-class-name="table-header"
                    class-name="table-number"
                >

                </el-table-column>

                <el-table-column
                    prop="f2"
                    label="广告金(元)"
                    min-width="160"
                    :formatter="value_format2"
                    label-class-name="table-header"
                    class-name="table-number"
                >

                </el-table-column>

                <el-table-column
                    prop="f3"
                    label="返点(元)"
                    min-width="160"
                    :formatter="value_format2"
                    label-class-name="table-header"
                    class-name="table-number"
                >

                </el-table-column>

                <el-table-column
                    prop="f8"
                    label="框返(元)"
                    min-width="180"
                    :formatter="value_format2"
                    label-class-name="table-header"
                    class-name="table-number"
                >

                </el-table-column>

                <el-table-column
                    prop="jlzc"
                    label="激励政策收入(元)"
                    label-class-name="table-header"
                    class-name="table-number"
                    min-width="160"
                    :formatter="value_format2"
                >

                </el-table-column>

                <el-table-column
                    prop="f6"
                    label="赔付(元)"
                    label-class-name="table-header"
                    class-name="table-number"
                    min-width="160"
                    :formatter="value_format2"
                >

                </el-table-column>
              </el-table-column>


            </el-table>

            <el-pagination
                v-show="activeName==='third'"
                class="y4-pagination"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="incomeDetailRows.length"
                :page-size="incomePageSize"
                :page-sizes="[50, 100, 200, 500]"
                :current-page.sync="incomeCurrentPage"
                @size-change="handleIncomePageSizeChange"
                @current-change="handleIncomePageChange">
            </el-pagination>

            <div v-show="activeName!=='4' && activeName!=='third'" style="margin-top: 10px; text-align: right; color: #666; font-size: 14px;">
              共 {{ (tableData || []).length }} 条记录
            </div>
            <!--        //预估倍率-->
            <el-pagination
                v-show="activeName==='4'"
                class="y4-pagination y4-pagination-top"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="(tableDataY4 || []).length"
                :page-size="tableDataY4PageSize"
                :page-sizes="[50, 100, 200, 500]"
                :current-page.sync="tableDataY4CurrentPage"
                @size-change="handleY4PageSizeChange"
                @current-change="handleY4PageChange">
            </el-pagination>
            <el-table
                ref="tableData1"
                v-show="activeName==='4'"
                :data="pagedTableDataY4"
                :height="tableHeight"
                style="margin-top: 11px;"
                :row-class-name="tableRowClassName"
                :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
                size="mini"
                v-loading="loading"
                highlight-current-row
                @sort-change="customSort"
            >

              <el-table-column
                  prop="uploadDate"
                  label="日期"
                  sortable="custom"

                  v-if="visibleColumns.includes('uploadDate')"
                  min-width="130"

              >

              </el-table-column>
              <el-table-column
                  prop="gameTypeConfig.gameType"
                  label="品类"
                  v-if="visibleColumns.includes('gameType')"
                  min-width="80"

              >

              </el-table-column>
              <el-table-column
                  prop="gameName"
                  label="游戏名称"
                  min-width="150"
                  v-if="visibleColumns.includes('gameName')"
              >

                <template slot-scope="{row}">

                  <span style=" font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;">{{ row.gameName }}</span>

                </template>
              </el-table-column>
              <el-table-column
                  prop="statCost"
                  label="消耗"
                  min-width="100"
                  sortable="custom"
                  v-if="visibleColumns.includes('statCost')"
              >
                <template slot-scope="{row}">

                  {{ row.statCost|dataFilters2 }}

                </template>
              </el-table-column>

              <!--          <el-table-column-->
              <!--              prop="statCost"-->
              <!--              label="实际消耗"-->
              <!--              min-width="100"-->

              <!--          >-->
              <!--            <template slot-scope="{row}">-->

              <!--              {{ row.statCost - row.pfAmount|dataFilters2 }}-->

              <!--            </template>-->

              <!--          </el-table-column>-->
              <el-table-column
                  prop="estimatedProfit"
                  label="预估利润"
                  min-width="100"
                  sortable="custom"

                  v-if="visibleColumns.includes('profit')"
              >
                <template slot-scope="{row}">

              <span
                  :class="((Math.max(row.roi3, row.roi7, row.roi15, row.roi30, row.roi45, row.roi60, row.roi75, row.roi90, row.roi105, row.roi120, row.roi135, row.roi150) * row.roi0 - 1) * (row.statCost - row.pfAmount))>0?'red':'green'">

                {{
                  ((Math.max(row.roi3, row.roi7, row.roi15, row.roi30, row.roi45, row.roi60, row.roi75, row.roi90, row.roi105, row.roi120, row.roi135, row.roi150) * row.roi0 - 1) * (row.statCost - row.pfAmount)).toFixed(2)
                }}
              </span>

                </template>

              </el-table-column>
              <el-table-column
                  prop="roi3"
                  label="预估ROI|倍率"
                  min-width="120"
                  v-if="visibleColumns.includes('roiInfo')"
              >
                <template slot-scope="{row}">

              <span :class="y4BestRoiClass(row)">
                {{
                  (Math.max(row.roi3, row.roi7, row.roi15, row.roi30, row.roi45, row.roi60, row.roi75, row.roi90, row.roi105, row.roi120, row.roi135, row.roi150) * row.roi0 * 100).toFixed(2) + '%'
                }}

              </span>|
                  <span :class="y4BestRateClass(row)">{{
                      Math.max(row.roi3, row.roi7, row.roi15, row.roi30, row.roi45, row.roi60, row.roi75, row.roi90, row.roi105, row.roi120, row.roi135, row.roi150)|dataFilters2

                    }}</span>

                </template>

              </el-table-column>
              <el-table-column
                  prop="maxNonZeroDay"
                  label="预估周期"
                  v-if="visibleColumns.includes('maxNonZeroDay')"
                  min-width="80"
              >
                <template slot-scope="{row}">
                  {{ getMaxNonZeroDay(row) }}
                </template>
              </el-table-column>

              <el-table-column
                  prop="roi1"
                  label="1日ROI"
                  min-width="120"

              >
                <template slot-scope="{row}">
                  <!-- ROI显示部分 -->
                  <span v-show="checkedCities2.includes('ROI')">
      <span
          :class="y4DayRoiClass(row, 1)"
          v-if="row.descType <= 1"
      >
        {{ formatY4DayRoi(row, 1) }}
      </span>
      <span :class="y4DayRoiClass(row, 1)" v-else>
        {{ formatY4DayRoi(row, 1) }}
      </span>
    </span>
                  <!-- 分隔符 -->
                  <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>
                  <!-- 倍率显示部分 -->
                  <span v-show="checkedCities2.includes('倍率')">
      <span
          :class="y4DayRateClass(row, 1)"
          v-if="row.descType <= 1"
      >
        {{ formatY4DayRate(row, 1) }}
      </span>
      <span :class="y4DayRateClass(row, 1)" v-else>
        {{ formatY4DayRate(row, 1) }}
      </span>
    </span>
                  <i
                      v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi2,')"
                      class="el-icon-star-on updated-marker-icon"
                      title="根据品类分组预估">
                  </i>
                </template>
              </el-table-column>


              <el-table-column
                  prop="roi2"
                  label="2日ROI"
                  min-width="120"
                  v-if="visibleColumns.includes('roi2')"
              >
                <template slot-scope="{row}">
                  <!-- ROI显示部分 -->
                  <span v-show="checkedCities2.includes('ROI')">
      <span
          :class="y4DayRoiClass(row, 2)"
          v-if="row.descType <= 2"
      >
        {{ formatY4DayRoi(row, 2) }}
      </span>
      <span :class="y4DayRoiClass(row, 2)" v-else>
        {{ formatY4DayRoi(row, 2) }}
      </span>
    </span>
                  <!-- 分隔符 -->
                  <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>
                  <!-- 倍率显示部分 -->
                  <span v-show="checkedCities2.includes('倍率')">
      <span
          :class="y4DayRateClass(row, 2)"
          v-if="row.descType <= 2"
      >
        {{ formatY4DayRate(row, 2) }}
      </span>
      <span :class="y4DayRateClass(row, 2)" v-else>
        {{ formatY4DayRate(row, 2) }}
      </span>
    </span>
                  <i
                      v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi2,')"
                      class="el-icon-star-on updated-marker-icon"
                      title="根据品类分组预估">
                  </i>
                </template>
              </el-table-column>

               第3日ROI独立列
                        <el-table-column
                            prop="roi3"
                            label="3日ROI"
                            min-width="150"
                            v-if="visibleColumns.includes('roi3')"
                        >
                          <template slot-scope="{row}">
                            <!-- ROI显示部分 -->
                            <span v-show="checkedCities2.includes('ROI')">
                    <span
                        :class="y4DayRoiClass(row, 3)"
                        v-if="row.descType <= 3"
                    >
                      {{ formatY4DayRoi(row, 3) }}
                    </span>
                    <span :class="y4DayRoiClass(row, 3)" v-else>
                      {{ formatY4DayRoi(row, 3) }}
                    </span>
                  </span>
                            <!-- 分隔符 -->
                            <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>
                            <!-- 倍率显示部分 -->
                            <span v-show="checkedCities2.includes('倍率')">
                    <span
                        :class="y4DayRateClass(row, 3)"
                        v-if="row.descType <= 3"
                    >
                      {{ formatY4DayRate(row, 3) }}
                    </span>
                    <span :class="y4DayRateClass(row, 3)" v-else>
                      {{ formatY4DayRate(row, 3) }}
                    </span>
                  </span>
                            <i
                                v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi3,')"
                                class="el-icon-star-on updated-marker-icon"
                                title="根据品类分组预估">
                            </i>
                          </template>
                        </el-table-column>

              <!-- 第4日ROI独立列 -->
              <el-table-column
                  prop="roi4"
                  label="4日ROI"
                  min-width="120"
                  v-if="visibleColumns.includes('roi4')"
              >
                <template slot-scope="{row}">
                  <!-- ROI显示部分 -->
                  <span v-show="checkedCities2.includes('ROI')">
      <span
          :class="y4DayRoiClass(row, 4)"
          v-if="row.descType <= 4"
      >
        {{ formatY4DayRoi(row, 4) }}
      </span>
      <span :class="y4DayRoiClass(row, 4)" v-else>
        {{ formatY4DayRoi(row, 4) }}
      </span>
    </span>
                  <!-- 分隔符 -->
                  <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>
                  <!-- 倍率显示部分 -->
                  <span v-show="checkedCities2.includes('倍率')">
      <span
          :class="y4DayRateClass(row, 4)"
          v-if="row.descType <= 4"
      >
        {{ formatY4DayRate(row, 4) }}
      </span>
      <span :class="y4DayRateClass(row, 4)" v-else>
        {{ formatY4DayRate(row, 4) }}
      </span>
    </span>
                  <i
                      v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi4,')"
                      class="el-icon-star-on updated-marker-icon"
                      title="根据品类分组预估">
                  </i>
                </template>
              </el-table-column>

              <!-- 第5日ROI独立列 -->
              <el-table-column
                  prop="roi5"
                  label="5日ROI"
                  min-width="120"
                  v-if="visibleColumns.includes('roi5')"
              >
                <template slot-scope="{row}">
                  <!-- ROI显示部分 -->
                  <span v-show="checkedCities2.includes('ROI')">
      <span
          :class="y4DayRoiClass(row, 5)"
          v-if="row.descType <= 5"
      >
        {{ formatY4DayRoi(row, 5) }}
      </span>
      <span :class="y4DayRoiClass(row, 5)" v-else>
        {{ formatY4DayRoi(row, 5) }}
      </span>
    </span>
                  <!-- 分隔符 -->
                  <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>
                  <!-- 倍率显示部分 -->
                  <span v-show="checkedCities2.includes('倍率')">
      <span
          :class="y4DayRateClass(row, 5)"
          v-if="row.descType <= 5"
      >
        {{ formatY4DayRate(row, 5) }}
      </span>
      <span :class="y4DayRateClass(row, 5)" v-else>
        {{ formatY4DayRate(row, 5) }}
      </span>
    </span>
                  <i
                      v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi5,')"
                      class="el-icon-star-on updated-marker-icon"
                      title="根据品类分组预估">
                  </i>
                </template>
              </el-table-column>

              <!-- 第6日ROI独立列 -->
              <el-table-column
                  prop="roi6"
                  label="6日ROI"
                  min-width="120"
                  v-if="visibleColumns.includes('roi6')"
              >
                <template slot-scope="{row}">
                  <!-- ROI显示部分 -->
                  <span v-show="checkedCities2.includes('ROI')">
      <span
          :class="y4DayRoiClass(row, 6)"
          v-if="row.descType <= 6"
      >
        {{ formatY4DayRoi(row, 6) }}
      </span>
      <span :class="y4DayRoiClass(row, 6)" v-else>
        {{ formatY4DayRoi(row, 6) }}
      </span>
    </span>
                  <!-- 分隔符 -->
                  <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>
                  <!-- 倍率显示部分 -->
                  <span v-show="checkedCities2.includes('倍率')">
      <span
          :class="y4DayRateClass(row, 6)"
          v-if="row.descType <= 6"
      >
        {{ formatY4DayRate(row, 6) }}
      </span>
      <span :class="y4DayRateClass(row, 6)" v-else>
        {{ formatY4DayRate(row, 6) }}
      </span>
    </span>
                  <i
                      v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi6,')"
                      class="el-icon-star-on updated-marker-icon"
                      title="根据品类分组预估">
                  </i>
                </template>
              </el-table-column>
              <!-- 方法1: 使用 template 包裹（推荐） -->
              <template v-for="(day) in roiDays">
                <el-table-column
                    :key="day"
                    v-if="visibleColumns.includes('roiColumns')"
                    :prop="'roi' + day"
                    :label="`${day}日ROI`"
                    min-width="150"
                >
                  <template slot-scope="{row}">
                    <!-- ROI显示部分 -->
                    <span v-show="checkedCities2.includes('ROI')" v-if="safeY4Number(row['roi' + day]) > 0">
        <span
            :class="y4DayRoiClass(row, day)"
            v-if="row.descType <=day"
        >
          {{ `  ${(row[`roi${day}`] * row.roi0 * 100).toFixed(2)}%` }}
        </span>
        <span :class="y4DayRoiClass(row, day)" v-else>
          {{ `  ${(row[`roi${day}`] * row.roi0 * 100).toFixed(2)}%` }}
        </span>
      </span>
                    <span v-show="checkedCities2.includes('ROI')" v-else>-</span>
                    <!-- 分隔符 -->
                    <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>
                    <!-- 倍率显示部分 -->
                    <span v-show="checkedCities2.includes('倍率')">
        <span
            :class="y4DayRateClass(row, day)"
            v-if="row.descType <=day"
        >
          {{ row[`roi${day}`] | dataFilters2 }}
        </span>
        <span :class="y4DayRateClass(row, day)" v-else>
          {{ row[`roi${day}`] | dataFilters2 }}
        </span>
      </span>
                    <i
                        v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',' + `roi${day}` + ',')"
                        class="el-icon-star-on updated-marker-icon"
                        title="根据品类分组预估">
                    </i>
                  </template>
                </el-table-column>
              </template>


              <el-table-column
                  prop="groupLabel"
                  label="标签"
                  v-if="visibleColumns.includes('groupLabel')"
                  min-width="150"

              >

              </el-table-column>

              <el-table-column
                  prop="groupLabel"
                  label="素材排行"
                  min-width="150"

              >
                <template slot-scope="{row}">

                  <el-button type="primary" size="mini" @click="findMaterial(row)">素材排行</el-button>

                </template>

              </el-table-column>
            </el-table>

            <el-pagination
                v-show="activeName==='4'"
                class="y4-pagination"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="(tableDataY4 || []).length"
                :page-size="tableDataY4PageSize"
                :page-sizes="[50, 100, 200, 500]"
                :current-page.sync="tableDataY4CurrentPage"
                @size-change="handleY4PageSizeChange"
                @current-change="handleY4PageChange">
            </el-pagination>
          </el-tabs>
        </div>


      </div>

      <!-- 素材排行榜对话框 -->
      <el-dialog title="素材排行榜" :visible.sync="materialDialogVisible" width="60%" top="5vh" >
        <el-table
            :data="tableMaterial"
            v-loading="loading3"
            ref="tableData8"
            stripe
            max-height="800"
            highlight-current-row>
          <el-table-column prop="material_id" label="素材ID" width="180"></el-table-column>

          <el-table-column prop="material_id" label="素材图片" min-width="150" align="center">
            <template slot-scope="{row}">
              <div class="image-container" @click="showImagePreview(row.video_poster)">
                <img
                    :src="row.video_poster"
                    style="height:75px"
                    alt="素材图片"
                    class="material-image"
                    v-if="row.video_poster"
                    @error="handleImageError"
                />
                <span v-else>无图片</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="video_name" label="来源" min-width="100" >

          </el-table-column>
          <el-table-column prop="cost" label="消耗" min-width="100" >
            <template slot-scope="{row}">
              {{ row.cost | dataFilters2 }}
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            layout="prev, pager, next, jumper, ->, total"
            :total="200"
            :page-size="materialPageSize"
            :current-page.sync="materialCurrentPage"
            @current-change="handleMaterialPageChange"
            style="margin-top: 15px; text-align: right;">
        </el-pagination>

        <span slot="footer" class="dialog-footer">
    <el-button @click="materialDialogVisible = false">关闭</el-button>
  </span>
      </el-dialog>

      <!-- 图片预览对话框 -->
      <el-dialog :visible.sync="imagePreviewVisible" width="60%" top="10vh" append-to-body>
        <img :src="previewImageUrl" alt="预览图片" class="preview-image" />
      </el-dialog>
    </el-container>

  </div>


</template>
<script>
import draggable from 'vuedraggable'

const cityOptions = ['游戏名', '日期'];
const cityOptions2 = ['ROI', '倍率'];
const cityOptions3 = ['游戏名', '日期', '品类'];
const y4DefaultVisibleColumns = ['uploadDate', 'roiColumns', 'gameType', 'gameName', 'statCost', 'profit', 'roiInfo', 'maxNonZeroDay', 'roi0', 'groupLabel', 'roi2', 'roi3', 'roi4', 'roi5', 'roi6'];
export default {

  name: "ToufangBroad",

  data() {

    return {
      resizeTimer: null,
      tableHeight: 0,

      materialDialogVisible: false,
      tableMaterial: [],
      materialPageSize: 10,
      materialCurrentPage: 1,
      loading3: false,
      imagePreviewVisible: false,
      previewImageUrl: '',
      showChart: false,
      columnVisibility: {
        uploadDate: true,
        gameType: true,
        gameName: true,
        statCost: true,
        profit: true,
        roiInfo: true,
        maxNonZeroDay: true,
        roi0: true,
        groupLabel: true,
        // 可以为 roiDays 列也添加控制
        roiColumns: true
      }, columnOptions: [
        {value: 'uploadDate', label: '日期'},
        {value: 'gameType', label: '品类'},
        {value: 'gameName', label: '游戏名称'},
        {value: 'statCost', label: '消耗'},
        {value: 'profit', label: '预估利润'},
        {value: 'roiInfo', label: '预估ROI|倍率'},
        {value: 'maxNonZeroDay', label: '预估周期'},
        {value: 'roi0', label: '首日ROI'},
        {value: 'roiColumns', label: 'ROI列'},
        {value: 'groupLabel', label: '标签'},
        {value: 'roi2', label: '2日ROI'},
        {value: 'roi3', label: '3日ROI'},
        {value: 'roi4', label: '4日ROI'},
        {value: 'roi5', label: '5日ROI'},
        {value: 'roi6', label: '6日ROI'}
      ],
      visibleColumns: ['uploadDate', 'roiColumns', 'gameType', 'gameName', 'statCost', 'profit', 'roiInfo', 'maxNonZeroDay', 'roi0', 'groupLabel', 'roi2', 'roi3', 'roi4', 'roi5', 'roi6'],
      selectedDays: [3, 7],
      chart: null,
      showCost3: false,
      showCost: false,
      showCost2: false,
      chartOptions: {
        tooltip: {
          trigger: 'axis',

          axisPointer: {type: 'cross'},
          formatter: params => {
            let res = `<div style="display: flex; justify-content: space-between;">`;

            // 分类存储 ROI 和倍率数据
            const roiItems = [];
            const rateItems = [];

            params.forEach(item => {
              const color = String(item.color || '#666'); // 安全转换颜色值
              const valueText = `${item.value}${item.seriesType === 'cost' ? '元' : ''}`;

              if (item.seriesName.includes('ROI')) {
                roiItems.push(`          <div style="display: flex; align-items: center;">
            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>
            ${item.seriesName}: ${valueText}%
          </div>
        `);
              } else if (item.seriesName.includes('倍率')) {
                rateItems.push(`          <div style="display: flex; align-items: center;">
            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>
            ${item.seriesName}: ${valueText}          </div>
        `);
              }
            });

            // 左侧列：ROI 数据
            res += `<div style="flex: 1; padding-right: 10px;">`;
            if (roiItems.length > 0) {
              res += `<strong>ROI:</strong><br>` + roiItems.join('');
            }
            res += `</div>`;

            // 右侧列：倍率数据
            res += `<div style="flex: 1; padding-left: 10px; border-left: 1px solid #ccc;">`;
            if (rateItems.length > 0) {
              res += `<strong>倍率:</strong><br>` + rateItems.join('');
            }
            res += `</div>`;

            res += `</div>`;
            return res;
          }
        },
        legend: {
          data: [],
          bottom: 0,
          left: 'center',
          type: 'scroll'
        }, grid: {
          left: '5%'
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 45,
            formatter: value => {
              const date = new Date(value)
              return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
            }
          }
        },
        yAxis: [
          { // ROI轴
            type: 'value',
            name: 'ROI (%)',
            position: 'left',

            axisLabel: {formatter: '{value}%'}
          },
          { // 倍率轴
            type: 'value',
            name: '倍率',
            position: 'right',
            offset: 30,
            axisLine: {
              show: true,
              lineStyle: {color: '#68b1fc'}
            }
          },
          { // 消耗轴
            type: 'value',
            name: '消耗 (元)',
            position: 'right',
            offset: 80,
            axisLine: {
              show: true,
              lineStyle: {color: '#f56a6a'}
            }
          },
          // ,
          // { // 消耗轴
          //   type: 'value',
          //   name: '实际消耗 (元)',
          //   position: 'right',
          //   offset: 140,
          //   axisLine: {
          //     show: true,
          //     lineStyle: { color: '#FF5722' }
          //   }
          // }
        ],
        series: []
      },
      roiDays: [ 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150],
      optionsYType: [{label: "对数预估", value: "1"}, {label: "比例预估", value: "2"}],
      tableData5: [],
      yType: "2",
      dialogFormVisible: false,
      backfillDialogVisible: false,
      backfillLoading: false,
      backfillTask: null,
      backfillTaskTimer: null,
      liveGameDialogVisible: false,
      liveGameLoading: false,
      liveGameSaving: false,
      liveGameList: [],
      liveGameForm: {
        gameName: '',
        remark: ''
      },
      backfillForm: {
        date: [],
        gameNames: [],
        includeFlowIncome: true,
        includeCashCost: true,
        includeRoi: false,
        includeToufang: true
      },
      checkedCities: ['游戏名', '日期'],

      checkedCities2: ['ROI', '倍率'],
      activeName: '4',
      cities: cityOptions,
      checkedYugu: ['游戏名', '日期'],
      citiesYugu: cityOptions3,
      cities2: cityOptions2,
      isSort: true,
      list: [],
      value1: [],
      currentPage: 1,
      options3: ['流量主比例', '广告金比例', '返点比例', '框返比例'],
      valueScene: '',
      fl: false,
      tableDataY4: [],
      tableDataY4CurrentPage: 1,
      tableDataY4PageSize: 100,
      showChartROI: true, // 控制图表中 ROI 是否显示，默认为 true
      showChartRate: true, // 控制图表中倍率是否显示，默认为 true
      loading: false,
      registerDate: "",
      type: 'pv',
      valueUser: "",
      avgEcpm: 0,
      value5: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      gameType: '',
      tableDataType: [],
      tableData: [],//营收
      incomeCurrentPage: 1,
      incomePageSize: 100,
      incomeGroupHintShown: false,
      tableData2: [],
      optionsGame: [],
      optionsPerson: [],
      optionsDay: ['按最新', 3, 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150],
      valueDay: 3,
      valuePerson: "",
      valueGame: "",
      value: 0,
      value2: '',
      value3: 7
      , json_data: []
      , json_fields: {
        '游戏名称': 'c_name',
        '日期': 'c_date',
        '利润(元)': 'profit',
        '账面消耗': 'c_amount',
        '现金消耗(元)': 'sum_cost_cash',
        '流量主收入(元)分成后': 'f1',
        '广告金(元)': 'f2',
        '返点(元)': 'f3',
        '框返(元)': 'f8',
        '激励政策收入(元)': 'jlzc',
        '赔付(元)': 'f6'
      }, json_data2: []
      , json_fields2: {
        '游戏名称': 'aname',
        '日期': 'cDate',
        '账面消耗': 'cAmount',
        '实际消耗': 'r1',
        '预估消耗(元)': 'r2',
        '现金消耗(元)': 'sumCashCost',
        '预估利润（元）': 'ygProfit',
        '实时利润（元）含广告金+实际赔付': 'r3'
      },
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: '',
      items: ["7", "15", "30", "45", "60", "75", "90", "105", "120", "135", "150"],
      isSearch: true,
      form: {
        allDivisionScale: 0,
        divisionScale: 0.1,
        type: '流量主比例',
        date: [],
        checked: true
      },
      formLabelWidth: '140px',


    }


  }, computed: {
    incomeSummaryRows() {
      const rows = Array.isArray(this.tableData) ? this.tableData : [];
      return rows.filter(row => this.isIncomeSummaryRow(row));
    },
    incomeDetailRows() {
      const rows = Array.isArray(this.tableData) ? this.tableData : [];
      return rows.filter(row => !this.isIncomeSummaryRow(row));
    },
    pagedIncomeTableData() {
      const pageSize = Number(this.incomePageSize) || 100;
      const currentPage = Math.max(Number(this.incomeCurrentPage) || 1, 1);
      const start = (currentPage - 1) * pageSize;
      return this.incomeSummaryRows.concat(this.incomeDetailRows.slice(start, start + pageSize));
    },
    pagedTableDataY4() {
      const rows = Array.isArray(this.tableDataY4) ? this.tableDataY4 : [];
      const pageSize = Number(this.tableDataY4PageSize) || 100;
      const currentPage = Math.max(Number(this.tableDataY4CurrentPage) || 1, 1);
      const start = (currentPage - 1) * pageSize;
      return rows.slice(start, start + pageSize);
    },
    uniqueGameTypes() {
      // 从 tableData 中提取唯一的 gameType 值
      const gameTypes = this.tableDataType
          .map(item => item.gameType)
          .filter(type => type !== undefined && type !== null && type !== '');

      // 使用 Set 去重
      return [...new Set(gameTypes)];
    },
    backfillTaskAlertType() {
      if (!this.backfillTask) {
        return 'info'
      }
      if (this.backfillTask.status === 'SUCCESS') {
        return 'success'
      }
      if (this.backfillTask.status === 'FAILED') {
        return 'warning'
      }
      return 'info'
    },
    backfillTaskTitle() {
      if (!this.backfillTask) {
        return ''
      }
      if (this.backfillTask.status === 'SUCCESS') {
        return '补发任务已完成'
      }
      if (this.backfillTask.status === 'FAILED') {
        return '补发任务完成，但存在失败项'
      }
      return '补发任务进行中'
    }

  }, watch: {

    colOptions(valArr) {
      // alert("sss");
      this.$nextTick(() => {
        this.$refs.tableDataRef.doLayout();
      });
    },
    valueGame() {
      this.saveToufangBroadCache();
    },
    value2: {
      handler() {
        this.saveToufangBroadCache();
      },
      deep: true
    },
    value5() {
      this.saveToufangBroadCache();
    },
    activeName() {
      this.saveToufangBroadCache();
    },
    gameType() {
      this.saveToufangBroadCache();
    },
    checkedCities: {
      handler() {
        this.saveToufangBroadCache();
      },
      deep: true
    },
    checkedYugu: {
      handler() {
        this.saveToufangBroadCache();
      },
      deep: true
    },
    checkedCities2: {
      handler() {
        this.saveToufangBroadCache();
      },
      deep: true
    },
    visibleColumns: {
      handler() {
        this.saveToufangBroadCache();
        this.$nextTick(() => {
          if (this.$refs.tableData1) {
            this.$refs.tableData1.doLayout();
          }
        });
      },
      deep: true
    },
    selectedDays: {
      handler() {
        this.saveToufangBroadCache();
      },
      deep: true
    },
    showChart() {
      this.saveToufangBroadCache();
    },
    showCost() {
      this.saveToufangBroadCache();
    },
    showCost2() {
      this.saveToufangBroadCache();
    },
    showCost3() {
      this.saveToufangBroadCache();
    },
    showChartROI() {
      this.saveToufangBroadCache();
    },
    showChartRate() {
      this.saveToufangBroadCache();
    },
    yType() {
      this.saveToufangBroadCache();
    },
    tableDataY4PageSize() {
      this.saveToufangBroadCache();
    }
  }, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (!isFinite(Number(value))) {

        return '-'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }, dataFilters2(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (!isFinite(Number(value))) {

        return "-"

      } else {

        return Number(value).toFixed(2)

      }
    },
    dataFilters3(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')


      }
    }, dataFilters4(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {

        return value.toFixed(2) + '%'
      }

    }
  },
  methods: {
    isIncomeSummaryRow(row) {
      if (!row) {
        return false
      }
      const dateText = String(row.c_date || '').replace(/\s/g, '')
      const nameText = String(row.c_name || '').replace(/\s/g, '')
      return row.isIncomeSummary === true || dateText === '合计' || nameText === '合计'
    },
    incomeSortValue(value) {
      if (value === null || value === undefined || value === '' || value === '-') {
        return 0
      }
      const numberValue = Number(String(value).replace(/,/g, ''))
      return Number.isFinite(numberValue) ? numberValue : 0
    },
    sortByIncomeNumber(prop) {
      return (a, b) => this.incomeSortValue(a && a[prop]) - this.incomeSortValue(b && b[prop])
    },
    handleIncomePageSizeChange(size) {
      this.incomePageSize = Number(size) || 100
      this.incomeCurrentPage = 1
      this.saveToufangBroadCache()
      this.refreshIncomeTableLayout()
    },
    handleIncomePageChange(page) {
      this.incomeCurrentPage = Number(page) || 1
      this.refreshIncomeTableLayout()
    },
    handleIncomeSortChange({prop, order}) {
      if (!prop || !order) {
        return
      }
      const summaryRows = (this.tableData || []).filter(row => this.isIncomeSummaryRow(row))
      const detailRows = (this.tableData || []).filter(row => !this.isIncomeSummaryRow(row))
      const direction = order === 'ascending' ? 1 : -1
      detailRows.sort((a, b) => {
        if (prop === 'c_date' || prop === 'c_name') {
          return String((a && a[prop]) || '').localeCompare(String((b && b[prop]) || ''), 'zh-Hans-CN') * direction
        }
        return (this.incomeSortValue(a && a[prop]) - this.incomeSortValue(b && b[prop])) * direction
      })
      this.tableData = summaryRows.concat(detailRows)
      this.incomeCurrentPage = 1
      this.refreshIncomeTableLayout()
    },
    refreshIncomeTableLayout() {
      this.$nextTick(() => {
        if (this.$refs.tableData1 && this.$refs.tableData1.doLayout) {
          this.$refs.tableData1.doLayout()
        }
      })
    },
    handleResize() {
      // 防抖处理
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        this.height = window.innerHeight;
        // 计算表格高度：窗口高度 - 其他元素占用的高度
        const containerHeight = window.innerHeight * 0.99; // 使用更大的容器高度
        const headerHeight = 40; // el-header 高度
        const tabsHeight = 40; // tabs 高度
        const chartHeight = this.showChart && this.activeName === '4' ? 300 : 0; // 图表高度（如果显示）
        const paginationHeight = (this.activeName === '4' || this.activeName === 'third') ? 82 : 0;
        const paddingHeight = 24 * 2 + 25 * 2; // .bbb1 和 .responsive-content 的上下 padding
        const otherHeight = 20; // 减少其他间距和边距
        
        this.tableHeight = containerHeight - headerHeight - tabsHeight - chartHeight - paddingHeight - otherHeight - paginationHeight;
        
        // 重新计算表格布局
        this.$nextTick(() => {
          if (this.$refs['tableData1']) {
            this.$refs['tableData1'].doLayout();
          }
          // 如果图表显示，重新渲染图表
          if (this.showChart && this.chart) {
            this.chart.resize();
          }
        });
      }, 300);
    },
// 处理图片加载错误
    handleImageError(event) {
      // 设置默认图片或隐藏图片
      event.target.style.display = 'none';
    },
    exportY4PredictionTable() {
      if (!Array.isArray(this.tableDataY4) || this.tableDataY4.length === 0) {
        this.$message.warning('暂无可导出的数据');
        return;
      }
      const XLSX = this.$xlsx;
      if (!XLSX || !XLSX.utils || !XLSX.writeFile) {
        this.$message.error('导出组件未加载');
        return;
      }
      const workbook = XLSX.utils.book_new();
      this.appendY4PredictionSheet(XLSX, workbook, '预估倍率', 'mixed');
      this.appendY4PredictionSheet(XLSX, workbook, 'ROI', 'roi');
      this.appendY4PredictionSheet(XLSX, workbook, '倍率', 'rate');
      XLSX.writeFile(workbook, this.y4ExportFileName());
      this.$message.success('导出成功');
    },
    appendY4PredictionSheet(XLSX, workbook, sheetName, metricMode) {
      const columns = this.y4ExportColumns(metricMode);
      const rows = this.tableDataY4.map(row => {
        const item = {};
        columns.forEach(column => {
          item[column.label] = column.value(row);
        });
        return item;
      });
      const headers = columns.map(column => column.label);
      const worksheet = XLSX.utils.json_to_sheet(rows, {header: headers});
      worksheet['!cols'] = columns.map(column => ({wch: column.width || 14}));
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    },
    y4ExportColumns(metricMode) {
      const isRoiOnly = metricMode === 'roi';
      const isRateOnly = metricMode === 'rate';
      const columns = [];
      if (this.visibleColumns.includes('uploadDate')) {
        columns.push({label: '日期', width: 14, value: row => row.uploadDate || '-'});
      }
      if (this.visibleColumns.includes('gameType')) {
        columns.push({
          label: '品类',
          width: 12,
          value: row => (row.gameTypeConfig && row.gameTypeConfig.gameType) || row.gameType || '-'
        });
      }
      if (this.visibleColumns.includes('gameName')) {
        columns.push({label: '游戏名称', width: 24, value: row => row.gameName || '-'});
      }
      if (this.visibleColumns.includes('statCost')) {
        columns.push({label: '消耗', width: 14, value: row => this.formatY4Money(row.statCost)});
      }
      if (metricMode === 'mixed' && this.visibleColumns.includes('profit')) {
        columns.push({label: '预估利润', width: 14, value: row => this.formatY4Money(this.y4EstimatedProfit(row))});
      }
      if (this.visibleColumns.includes('roiInfo')) {
        columns.push({
          label: isRoiOnly ? '预估ROI' : (isRateOnly ? '预估倍率' : '预估ROI|倍率'),
          width: 18,
          value: row => this.formatY4ExportMetric(row, null, metricMode)
        });
      }
      if (this.visibleColumns.includes('maxNonZeroDay')) {
        columns.push({label: '预估周期', width: 12, value: row => this.getMaxNonZeroDay(row)});
      }
      this.y4ExportDays().forEach(day => {
        columns.push({
          label: this.y4MetricColumnLabel(day, metricMode),
          width: 16,
          value: row => this.formatY4ExportMetric(row, day, metricMode)
        });
      });
      if (this.visibleColumns.includes('groupLabel')) {
        columns.push({label: '标签', width: 18, value: row => row.groupLabel || '-'});
      }
      return columns;
    },
    y4ExportDays() {
      const days = [1];
      [2, 3, 4, 5, 6].forEach(day => {
        if (this.visibleColumns.includes('roi' + day)) {
          days.push(day);
        }
      });
      if (this.visibleColumns.includes('roiColumns')) {
        this.roiDays.forEach(day => {
          if (days.indexOf(day) === -1) {
            days.push(day);
          }
        });
      }
      return days;
    },
    y4MetricColumnLabel(day, metricMode) {
      if (metricMode === 'roi') {
        return day + '日ROI';
      }
      if (metricMode === 'rate') {
        return day + '日倍率';
      }
      const includeRoi = this.checkedCities2.includes('ROI');
      const includeRate = this.checkedCities2.includes('倍率');
      if (includeRoi && includeRate) {
        return day + '日ROI|倍率';
      }
      return includeRate ? day + '日倍率' : day + '日ROI';
    },
    formatY4ExportMetric(row, day, metricMode) {
      const rate = day === null ? this.y4BestRate(row) : this.safeY4Number(row['roi' + day]);
      const roi = this.safeY4Number(row.roi0) * rate;
      if (metricMode === 'roi') {
        return this.formatY4Percent(roi);
      }
      if (metricMode === 'rate') {
        return this.formatY4Rate(rate);
      }
      return this.formatY4MetricCell(
          roi,
          rate,
          this.checkedCities2.includes('ROI'),
          this.checkedCities2.includes('倍率')
      );
    },
    formatY4MetricCell(roi, rate, includeRoi, includeRate) {
      const parts = [];
      if (includeRoi) {
        parts.push(this.formatY4Percent(roi));
      }
      if (includeRate) {
        parts.push(this.formatY4Rate(rate));
      }
      return parts.length > 0 ? parts.join(' | ') : '-';
    },
    formatY4DayRoi(row, day) {
      const rate = Number(row && row['roi' + day]);
      const roi0 = Number(row && row.roi0);
      if (!isFinite(rate) || !isFinite(roi0)) {
        return '-';
      }
      return this.formatY4Percent(rate * roi0);
    },
    formatY4DayRate(row, day) {
      return this.formatY4Rate(row && row['roi' + day]);
    },
    y4SourceValue(row) {
      if (!row) {
        return '';
      }
      return String(row.dataSource || row.datasource || row.data_source || '').trim();
    },
    y4RoiSourceKey(day) {
      return 'roi' + day + 'Source';
    },
    y4DaySource(row, day) {
      if (!row) {
        return '';
      }
      const keys = [
        this.y4RoiSourceKey(day),
        'roi' + day + '_source',
        'roi_' + day + '_source'
      ];
      for (const key of keys) {
        if (row[key] !== undefined && row[key] !== null && String(row[key]).trim() !== '') {
          return String(row[key]).trim();
        }
      }
      const lowerKey = ('roi' + day + 'Source').toLowerCase();
      const matchedKey = Object.keys(row).find(key => key.toLowerCase() === lowerKey);
      return matchedKey ? String(row[matchedKey] || '').trim() : '';
    },
    isY4ActualSource(source) {
      const value = String(source || '').trim().toLowerCase();
      return source === '真实' || value === 'actual' || value === 'real';
    },
    isY4EstimatedSource(source) {
      const value = String(source || '').trim().toLowerCase();
      return source === '预估' || source === '混合' || value === 'estimated' || value === 'estimate' || value === 'mixed';
    },
    mergeY4DaySource(group, item, day) {
      if (!group) {
        return;
      }
      const key = this.y4RoiSourceKey(day);
      const current = group[key];
      const next = this.y4DaySource(item, day);
      if (!next) {
        return;
      }
      if (!current) {
        group[key] = next;
      } else if (current !== next) {
        group[key] = '混合';
      }
    },
    markY4Sources(group, item) {
      if (!group || !item) {
        return;
      }
      [1, 2, 3, 4, 5, 6].concat(this.roiDays || []).forEach(day => {
        this.mergeY4DaySource(group, item, day);
      });
    },
    y4DisplaySourceKey(day) {
      return 'roi' + day + 'DisplaySource';
    },
    y4DisplayDaySource(row, day) {
      if (!row) {
        return '';
      }
      const value = row[this.y4DisplaySourceKey(day)];
      return value === undefined || value === null ? '' : String(value).trim();
    },
    mergeY4DisplaySource(group, item, day) {
      if (!group || !item) {
        return;
      }
      const key = this.y4DisplaySourceKey(day);
      const current = group[key];
      const next = this.isY4EstimatedDay(item, day) ? '预估' : '真实';
      if (!current) {
        group[key] = next;
      } else if (current !== next) {
        group[key] = '混合';
      }
    },
    markY4DisplaySources(group, item) {
      if (!group || !item) {
        return;
      }
      [1, 2, 3, 4, 5, 6].concat(this.roiDays || []).forEach(day => {
        this.mergeY4DisplaySource(group, item, day);
      });
    },
    hasY4DaySource(row, day) {
      return this.y4DaySource(row, day) !== '';
    },
    y4DayHasActualValue(row, day) {
      return this.safeY4Number(row && row['roi' + day]) > 0;
    },
    parseY4UploadDate(row) {
      if (!row) {
        return null;
      }
      const text = String(row.uploadDate || row.upload_date || row.statTimeDay || row.stat_time_day || row.date || '').slice(0, 10);
      const parts = text.split(/[-/]/).map(item => Number(item));
      if (parts.length < 3 || parts.some(item => !isFinite(item))) {
        return null;
      }
      const parsed = new Date(parts[0], parts[1] - 1, parts[2]);
      if (isNaN(parsed.getTime())) {
        return null;
      }
      parsed.setHours(0, 0, 0, 0);
      return parsed;
    },
    isY4DescTypeWindow(row) {
      const uploadDate = this.parseY4UploadDate(row);
      if (!uploadDate) {
        return true;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const diffDays = Math.floor((today.getTime() - uploadDate.getTime()) / 86400000);
      return diffDays <= 150;
    },
    isY4EstimatedDay(row, day) {
      if (!row) {
        return false;
      }
      if (!this.isY4DescTypeWindow(row)) {
        return false;
      }
      const displaySource = this.y4DisplayDaySource(row, day);
      if (this.isY4ActualSource(displaySource)) {
        return false;
      }
      const source = this.y4DaySource(row, day);
      if (this.isY4ActualSource(source)) {
        return false;
      }
      const descType = Number(row.descType);
      const roiDay = Number(day);
      if (isFinite(descType) && isFinite(roiDay)) {
        if (descType > roiDay) {
          return false;
        }
        if (this.isY4EstimatedSource(displaySource) || this.isY4EstimatedSource(source)) {
          return true;
        }
        return descType <= roiDay;
      }
      if (this.isY4EstimatedSource(displaySource) || this.isY4EstimatedSource(source)) {
        return true;
      }
      return false;
    },
    y4DayRoiClass(row, day) {
      return [
        this.isY4EstimatedDay(row, day) ? 'yugu2' : 'y4-real-value',
        this.isY4SummaryRow(row) ? 'y4-summary-value' : ''
      ].filter(Boolean).join(' ');
    },
    y4DayRateClass(row, day) {
      return [
        this.isY4EstimatedDay(row, day) ? 'yugu' : 'y4-real-value',
        this.isY4SummaryRow(row) ? 'y4-summary-value' : ''
      ].filter(Boolean).join(' ');
    },
    isY4SummaryRow(row) {
      if (!row) {
        return false;
      }
      return row.isSummary === true || row.gameName === '合计' || row.uploadDate === '合计';
    },
    y4BestDay(row) {
      const days = [3, 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150];
      let bestDay = 3;
      let bestRate = -Infinity;
      days.forEach(day => {
        const rate = this.safeY4Number(row && row['roi' + day]);
        if (rate > bestRate) {
          bestRate = rate;
          bestDay = day;
        }
      });
      return bestDay;
    },
    y4BestRoiClass(row) {
      return this.y4DayRoiClass(row, this.y4BestDay(row));
    },
    y4BestRateClass(row) {
      return this.y4DayRateClass(row, this.y4BestDay(row));
    },
    y4BestRate(row) {
      return Math.max(
          this.safeY4Number(row.roi3),
          this.safeY4Number(row.roi7),
          this.safeY4Number(row.roi15),
          this.safeY4Number(row.roi30),
          this.safeY4Number(row.roi45),
          this.safeY4Number(row.roi60),
          this.safeY4Number(row.roi75),
          this.safeY4Number(row.roi90),
          this.safeY4Number(row.roi105),
          this.safeY4Number(row.roi120),
          this.safeY4Number(row.roi135),
          this.safeY4Number(row.roi150)
      );
    },
    y4EstimatedProfit(row) {
      return (this.y4BestRate(row) * this.safeY4Number(row.roi0) - 1)
          * (this.safeY4Number(row.statCost) - this.safeY4Number(row.pfAmount));
    },
    formatY4Percent(value) {
      const numberValue = Number(value);
      return !isFinite(numberValue) || numberValue === 0 ? '-' : (numberValue * 100).toFixed(2) + '%';
    },
    formatY4Rate(value) {
      const numberValue = Number(value);
      if (!isFinite(numberValue) || numberValue === 0) {
        return '-';
      }
      return numberValue.toFixed(2);
    },
    formatY4Money(value) {
      const numberValue = Number(value);
      if (!isFinite(numberValue)) {
        return '-';
      }
      return numberValue.toFixed(2);
    },
    safeY4Number(value) {
      const numberValue = Number(value);
      return isFinite(numberValue) ? numberValue : 0;
    },
    sanitizeY4RoiGroup(group) {
      if (!group) {
        return group;
      }
      const days = [1, 2, 3, 4, 5, 6, 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150];
      group.roi0 = this.safeY4Number(group.roi0);
      days.forEach(day => {
        group['roi' + day] = this.safeY4Number(group['roi' + day]);
      });
      return group;
    },
    y4ExportFileName() {
      const dateRange = Array.isArray(this.value2) && this.value2.length === 2
          ? this.value2[0] + '_' + this.value2[1]
          : this.y4TodayText();
      const gameText = this.valueGame ? '_' + this.safeY4FileName(this.valueGame) : '';
      return '抖音预估倍率' + gameText + '_' + dateRange + '.xlsx';
    },
    y4TodayText() {
      const date = new Date();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return date.getFullYear() + '-' + month + '-' + day;
    },
    safeY4FileName(value) {
      return String(value || '').replace(/[\\/:*?"<>|]/g, '_');
    },
    handleMaterialPageChange(page) {
      this.materialCurrentPage = page;
      console.log(page);

      if (this.currentMaterialRow) {
        this.findMaterial(this.currentMaterialRow);
      }
    },
    handleY4PageSizeChange(size) {
      this.tableDataY4PageSize = size;
      this.tableDataY4CurrentPage = 1;
      this.refreshY4TableLayout();
    },
    handleY4PageChange(page) {
      this.tableDataY4CurrentPage = page;
      this.refreshY4TableLayout();
    },
    refreshY4TableLayout() {
      this.$nextTick(() => {
        if (this.$refs.tableData1 && this.$refs.tableData1.doLayout) {
          this.$refs.tableData1.doLayout();
        }
      });
    },
    // 显示图片预览
    showImagePreview(url) {
      if (url) {
        this.previewImageUrl = url;
        this.imagePreviewVisible = true;
      }
    },
    findMaterial(row) {

      // 如果传入了 row 参数，保存它以便分页时使用
      if (row && row.uploadDate && row.uploadDate !== "合计") {
        this.currentMaterialRow = row;
      }

      // 如果没有当前行信息，直接返回
      if (!this.currentMaterialRow) {
        return;
      }
      console.log(row.uploadDate)
      console.log(row.gameName)
      this.materialDialogVisible = true  // 显示对话框
      this.loading3 = true
      this.$axios
          .get('/toufang/data/findMaterialData/' + row.uploadDate+'/'+this.materialCurrentPage+'?name='+row.gameName, {})

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.loading3 = false

              this.tableMaterial = successResponse.data.data

              this.$nextTick(() => {
                if (this.$refs.tableData8) {
                  this.$refs.tableData8.doLayout();
                }
              });
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },

    tableRowClassName({row, rowIndex}) {
      const classes = [row.isDateTotal ? 'date-total-row' : 'date-total-row2'];
      if (this.isY4SummaryRow(row)) {
        classes.push('y4-summary-row');
      }
      if (this.isY4ActualData(row)) {
        classes.push('y4-actual-row');
      }
      return classes.join(' ');

    },
    isY4ActualData(row) {
      if (!row) {
        return false;
      }
      const source = this.y4SourceValue(row);
      return source === '真实' || source.toLowerCase() === 'actual' || source.toLowerCase() === 'real';
    },
    accumulateY4DataSource(group, item) {
      if (!group) {
        return;
      }
      if (this.isY4ActualData(item)) {
        group.actualDataCount = (group.actualDataCount || 0) + 1;
      } else {
        group.estimatedDataCount = (group.estimatedDataCount || 0) + 1;
      }
    },
    finalizeY4DataSource(group) {
      if (!group) {
        return;
      }
      const actualCount = group.actualDataCount || 0;
      const estimatedCount = group.estimatedDataCount || 0;
      if (actualCount > 0 && estimatedCount === 0) {
        group.dataSource = '真实';
      } else if (actualCount > 0 && estimatedCount > 0) {
        group.dataSource = '混合';
      } else if (estimatedCount > 0) {
        group.dataSource = '预估';
      }
      delete group.actualDataCount;
      delete group.estimatedDataCount;
    },
    getToufangBroadCache() {
      try {
        return JSON.parse(localStorage.getItem("ToufangBroad") || "{}") || {};
      } catch (e) {
        return {};
      }
    },
    saveToufangBroadCache() {
      const pageSize = [50, 100, 200, 500].includes(Number(this.tableDataY4PageSize))
          ? Number(this.tableDataY4PageSize)
          : 100;
      const incomePageSize = [50, 100, 200, 500].includes(Number(this.incomePageSize))
          ? Number(this.incomePageSize)
          : 100;
      localStorage.setItem("ToufangBroad", JSON.stringify({
        name: this.valueGame,
        date: this.value2,
        a: this.activeName,
        checkedCities: this.checkedCities,
        date2: this.value5,
        columns: this.visibleColumns,
        gameType: this.gameType,
        checkedYugu: this.checkedYugu,
        checkedCities2: this.checkedCities2,
        showChart: this.showChart,
        selectedDays: this.selectedDays,
        showCost: this.showCost,
        showCost2: this.showCost2,
        showCost3: this.showCost3,
        showChartROI: this.showChartROI,
        showChartRate: this.showChartRate,
        yType: this.yType,
        y4PageSize: pageSize,
        incomePageSize: incomePageSize
      }));
    },
    restoreToufangBroadCache() {
      const cache = this.getToufangBroadCache();
      if (Array.isArray(cache.checkedCities)) {
        this.checkedCities = cache.checkedCities;
      }
      if (Array.isArray(cache.checkedYugu)) {
        this.checkedYugu = cache.checkedYugu;
      }
      if (Array.isArray(cache.checkedCities2)) {
        this.checkedCities2 = cache.checkedCities2;
      }
      if (Array.isArray(cache.columns)) {
        this.visibleColumns = cache.columns;
      }
      if (Array.isArray(cache.selectedDays)) {
        this.selectedDays = cache.selectedDays;
      }
      if (Array.isArray(cache.date)) {
        this.value2 = cache.date;
      }
      if (typeof cache.name === 'string') {
        this.valueGame = cache.name;
      }
      if (cache.a !== undefined && cache.a !== null) {
        this.activeName = String(cache.a);
      }
      if (cache.date2 !== undefined) {
        this.value5 = cache.date2;
      }
      if (typeof cache.gameType === 'string') {
        this.gameType = cache.gameType;
      }
      if (cache.yType !== undefined && cache.yType !== null) {
        this.yType = String(cache.yType);
      }
      ['showChart', 'showCost', 'showCost2', 'showCost3', 'showChartROI', 'showChartRate'].forEach(key => {
        if (typeof cache[key] === 'boolean') {
          this[key] = cache[key];
        }
      });
      if ([50, 100, 200, 500].includes(Number(cache.y4PageSize))) {
        this.tableDataY4PageSize = Number(cache.y4PageSize);
      }
      if ([50, 100, 200, 500].includes(Number(cache.incomePageSize))) {
        this.incomePageSize = Number(cache.incomePageSize);
      }
    },
    // 在 methods 中添加
    ensureY4State() {
      if (!Array.isArray(this.checkedCities)) {
        this.checkedCities = cityOptions.slice();
      }
      if (!Array.isArray(this.checkedCities2)) {
        this.checkedCities2 = cityOptions2.slice();
      }
      if (!Array.isArray(this.checkedYugu)) {
        this.checkedYugu = cityOptions.slice();
      }
      if (!Array.isArray(this.visibleColumns)) {
        this.visibleColumns = y4DefaultVisibleColumns.slice();
      }
      if (!Array.isArray(this.tableDataY4)) {
        this.tableDataY4 = [];
      }
    },
    formatY4Date(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    currentYearY4Range() {
      const end = new Date();
      const start = new Date(end.getTime());
      start.setDate(start.getDate() - 6);
      return [this.formatY4Date(start), this.formatY4Date(end)];
    },
    ensureY4DateRange(forceDefault) {
      if (this.activeName !== '4') {
        return;
      }
      const invalidRange = !Array.isArray(this.value2)
          || this.value2.length !== 2
          || !this.value2[0]
          || !this.value2[1];
      if (forceDefault || invalidRange) {
        this.value2 = this.currentYearY4Range();
      }
    },
    resetColumns() {
      this.visibleColumns = y4DefaultVisibleColumns.slice();
      this.saveToufangBroadCache();
    },
    getMaxNonZeroDay(row) {
      let maxDay = 0;
      // 遍历所有 roiDays，找到最大的不为0的天数
      for (let i = this.roiDays.length - 1; i >= 0; i--) {
        const day = this.roiDays[i];
        if (row[`roi${day}`] !== 0 && row[`roi${day}`] !== undefined) {
          maxDay = day;
          break;
        }
      }
      return maxDay > 0 ? maxDay : '-';
    },
    processRoiData(data) {
      const processedData = [...data];
      processedData.forEach(item => {
        if (item.descType === 1) {
          // 找到 roi3 在 roiDays 中的索引
          const startIndex = this.roiDays.indexOf(3);
          // 如果找到了 roi3，则将它及之后的所有 ROI 设置为 0
          if (startIndex !== -1) {
            for (let i = startIndex; i < this.roiDays.length; i++) {
              const day = this.roiDays[i];
              item[`roi${day}`] = 0;
            }
          }
        }


        // 计算最大非零天数
        let maxDay = 0;
        for (let i = this.roiDays.length - 1; i >= 0; i--) {
          const day = this.roiDays[i];
          if (item[`roi${day}`] !== 0 && item[`roi${day}`] !== undefined) {
            maxDay = day;
            break;
          }
        }
        item.maxNonZeroDay = maxDay;

      });
      return processedData;
    },
    customSort({prop, order}) {
      this.ensureY4State()
      // 分离总合计行
      const totalSummary = this.tableDataY4.filter(item => item.uploadDate === '合计')
      // 分离日期合计行和普通数据行
      const otherData = this.tableDataY4.filter(item => item.uploadDate !== '合计')

      // 按日期分组数据
      const groupedData = {}
      otherData.forEach(item => {
        const date = item.uploadDate
        if (!groupedData[date]) {
          groupedData[date] = []
        }
        groupedData[date].push(item)
      })

      // 对每个日期组内的数据进行排序
      const sortedGroups = {}
      Object.keys(groupedData).forEach(date => {
        const group = groupedData[date]
        // 分离该日期的合计行
        const dateSummary = group.filter(item => item.isDateTotal)
        const normalData = group.filter(item => !item.isDateTotal)

        // 对普通数据进行排序
        const sortedNormalData = normalData.sort((a, b) => {
          if (prop === 'estimatedProfit') {
            // 预估利润排序
            const profitA = ((Math.max(a.roi3, a.roi7, a.roi15, a.roi30, a.roi45, a.roi60, a.roi75, a.roi90, a.roi105, a.roi120, a.roi135, a.roi150) * a.roi0 - 1) * (a.statCost - a.pfAmount))
            const profitB = ((Math.max(b.roi3, b.roi7, b.roi15, b.roi30, b.roi45, b.roi60, b.roi75, b.roi90, b.roi105, b.roi120, b.roi135, b.roi150) * b.roi0 - 1) * (b.statCost - b.pfAmount))
            if (order === 'ascending') {
              return profitA - profitB
            } else {
              return profitB - profitA
            }
          } else if (prop === 'statCost') {
            // 消耗排序
            if (order === 'ascending') {
              return a.statCost - b.statCost
            } else {
              return b.statCost - a.statCost
            }

          } else {
            // 其他列排序
            const aVal = a[prop]
            const bVal = b[prop]
            if (order === 'ascending') {
              return aVal > bVal ? 1 : -1
            } else {
              return aVal < bVal ? 1 : -1
            }
          }
        })

        // 合并该日期的数据：日期合计在最前，然后是排序后的普通数据
        sortedGroups[date] = [...dateSummary, ...sortedNormalData]

      })

      // 按日期排序所有组
      const sortedDates = Object.keys(sortedGroups).sort((a, b) => {
        if (prop === 'uploadDate') {
          // 日期排序
          if (order === 'ascending') {
            return a.localeCompare(b);
          } else {
            return b.localeCompare(a);
          }
        } else {
          // 非日期排序时保持原有顺序
          const datesInOrder = otherData.map(item => item.uploadDate);
          const indexA = datesInOrder.indexOf(a);
          const indexB = datesInOrder.indexOf(b);
          return indexA - indexB;
        }
      });

      // 合并所有排序后的数据
      const finalSortedData = []
      sortedDates.forEach(date => {
        finalSortedData.push(...sortedGroups[date])
      })

      // 最终结果：总合计在最前，然后是排序后的所有数据
      this.tableDataY4 = [...totalSummary, ...finalSortedData]
      this.tableDataY4CurrentPage = 1;

      this.$forceUpdate();
      this.$nextTick(() => {
        if (this.$refs.tableData1) {
          this.$refs.tableData1.doLayout();
        }
      });
    },
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart)
      this.updateChart()
    },
    updateChart() {
      this.saveToufangBroadCache();
      if (!this.showChart || !this.chart) {
        return;
      }
      // 生成动态配置
      const options = this.generateChartOptions()
      this.chart.setOption(options, true)
    },

    generateChartOptions() {
      // 获取合计行数据
      const totalRow = this.tableDataY4.find(item => item.gameName === '合计');
      const dateTotalRows = this.tableDataY4.filter(item => item.isDateTotal);
      const chartRows = dateTotalRows.length > 0
          ? dateTotalRows
          : this.tableDataY4.filter(item => item.gameName !== '合计');

      const mockData = chartRows.map(item => ({
        date: item.uploadDate,
        statCost: item.statCost || 0,
        statCost2: (item.statCost - item.pfAmount) || 0,
        profit: ((Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45, item.roi60, item.roi75, item.roi90, item.roi105, item.roi120, item.roi135, item.roi150) * item.roi0 - 1) * (item.statCost - item.pfAmount)).toFixed(2) || 0,
        ...this.roiDays.reduce((acc, day) => {
          acc[`roi${day}`] = item[`roi${day}`];
          acc[`roi${day}Percent`] = (item[`roi${day}`] * item.roi0 * 100).toFixed(2);
          return acc;
        }, {})
      }));
      // 动态生成系列配置
      const seriesConfig = [];

      // ROI 系列（受 showChartROI 控制）
      if (this.showChartROI) {
        seriesConfig.push(
            ...this.selectedDays.map(day => {
              const series = {
                name: `${day}日ROI`,
                type: 'line',
                yAxisIndex: 0,
                data: mockData.map(item => item[`roi${day}Percent`]),
                itemStyle: { color: this.getColor(day) },
                smooth: true
              };

              if (totalRow) {
                series.markLine = {
                  silent: true,
                  symbol: 'none',
                  lineStyle: { type: 'dashed', color: '#FF6B6B', width: 2 },
                  label: {
                    show: true,
                    position: 'start',
                    formatter: `${day}day ${(totalRow['roi' + day] * totalRow['roi0'] * 100).toFixed(1)}%`
                  },
                  data: [{ yAxis: (totalRow[`roi${day}`] * totalRow.roi0 * 100).toFixed(2) }]
                };
              }
              return series;
            }),
            // 100% ROI 基准线
            {
              name: '100% ROI基准线',
              type: 'line',
              yAxisIndex: 0,
              data: [],
              silent: true,
              symbol: 'none',
              lineStyle: { opacity: 0 },
              markLine: {
                symbol: 'none',
                lineStyle: { type: 'solid', color: '#666', width: 1 },
                label: { show: true, position: 'start', formatter: '100% ROI' },
                data: [{ yAxis: 100, x: '0%' }]
              }
            }
        );
      }

      // 倍率系列（受 showChartRate 控制）
      if (this.showChartRate) {
        seriesConfig.push(
            ...this.selectedDays.map(day => {
              const series = {
                name: `${day}日倍率`,
                type: 'line',
                yAxisIndex: 1,
                data: mockData.map(item => item[`roi${day}`]),
                itemStyle: { color: this.getColor(day) },
                lineStyle: { type: 'dashed' }
              };

              if (totalRow) {
                series.markLine = {
                  silent: true,
                  symbol: 'none',
                  lineStyle: { type: 'dashed', color: '#4ECDC4', width: 2 },
                  label: {
                    show: true,
                    position: 'end',
                    formatter: `${day}日合计 ${totalRow.roi3.toFixed(2)}`
                  },
                  data: [{ yAxis: totalRow[`roi${day}`] }]
                };
              }
              return series;
            })
        );
      }

      // 消耗、实际消耗、利润系列保持不变
      seriesConfig.push(
          ...(this.showCost ? [{
            name: '消耗',
            type: 'bar',
            yAxisIndex: 2,
            data: mockData.map(item => item.statCost),
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgb(245,106,106)' },
                { offset: 1, color: 'rgb(245,106,106)' }
              ])
            },
            barWidth: '60%',
            z: 1,
            barGap: '-100%'
          }] : []),
          ...(this.showCost2 ? [{
            name: '实际消耗',
            type: 'bar',
            yAxisIndex: 2,
            data: mockData.map(item => item.statCost2),
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgb(105,239,147)' },
                { offset: 1, color: 'rgb(105,239,147)' }
              ])
            },
            barWidth: '60%',
            z: 2,
            barGap: '-100%'
          }] : []),
          ...(this.showCost3 ? [{
            name: '利润',
            type: 'bar',
            yAxisIndex: 2,
            data: mockData.map(item => item.profit),
            itemStyle: {
              color: 'transparent',
              borderColor: '#529be5',
              borderWidth: 1.5
            },
            barWidth: '60%',
            z: 3,
            barGap: '-100%'
          }] : [])
      );

      return {
        ...this.chartOptions,
        xAxis: {
          ...this.chartOptions.xAxis,
          data: mockData.map(d => d.date)
        },
        series: seriesConfig.filter(s => s),
        legend: [
          {
            data: seriesConfig.filter(s => s?.name?.includes('日ROI')).map(s => s?.name),
            bottom: -5,
            left: 'left',
            type: 'scroll'
          },
          {
            data: seriesConfig.filter(s => s?.name?.includes('倍率')).map(s => s?.name),
            bottom: 10,
            left: 'left',
            type: 'scroll'
          }
        ]
      };
    },
    getColor(day) {
      // 按天数分配颜色
      const colorMap = {
        3: '#5470C6', 7: '#91CC75', 15: '#FAC858', 30: '#EE6666',
        45: '#73C0DE', 60: '#3BA272', 75: '#FC8452', 90: '#9A60B4',
        105: '#EA7CCC', 120: '#7C7C7C', 135: '#FF9999', 150: '#99CC99'
      }
      return colorMap[day] || '#666'
    },


    getCellClass({column}) {

      console.log(column)
      if (column.prop === 'cAmount') {
        return 'table-number2'
      }
      return ''
    },
    get() {

      this.$axios
          .get('/toufang/data/getDefault?type=' + this.form.type, {})

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.form.allDivisionScale = successResponse.data.data

            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })
    },
    change() {


      this.$axios
          .post('/toufang/data/updateDefault', this.form)

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.$message({
                message: '更新' + this.form.type + '默认值成功!',
                type: 'success'
              });
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },
    formDate(date) {
      // 将Excel日期转换为JavaScript日期
      const jsDate = new Date((date - 25569) * 86400 * 1000);
      // 将JavaScript日期转换为指定格式：yyyy-MM-dd
      const year = jsDate.getFullYear();
      const month = String(jsDate.getMonth() + 1).padStart(2, '0');
      const day = String(jsDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    changeExcel(e) {
      const files = e.target.files
      if (files.length <= 0) {
        return false
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        console.log('上传格式不正确，请上传xls或者xlsx格式')
        return false
      }
      // 读取表格
      const fileReader = new FileReader()
      fileReader.onload = ev => {
        const workbook = this.$xlsx.read(ev.target.result, {
          type: "binary"
        })
        const wsname = workbook.SheetNames[0]
        const ws = this.$xlsx.utils.sheet_to_json(workbook.Sheets[wsname])
        console.log('ws:', ws) // 转换成json的数据
        //  dealExcel(ws) ...对数据进行自己需要的操作
        // table2.value = ws

        var tt = this


        ws.forEach(function (element) {

          tt.$axios
              .post("/toufang/data/addIn", {
                date: tt.formDate(element.日期),
                name: element.游戏名称,
                jl: element.激励政策收入,
                pf: element.平台赔付
              })
              .then(successResponse => {

                console.log(successResponse)

                if (successResponse.data.code === 200) {

                  this.$notify({
                    title: '成功',
                    message: "添加成功",
                    type: 'success'
                  });
                }


              }).catch((err) => {
            //请求失败的回调函数
            console.log(err)
            console.log('失败')
          })

        });


      }
      fileReader.readAsBinaryString(files[0])
    },
    openBackfillDialog() {
      this.clearBackfillTimer()
      this.backfillTask = null
      const currentDate = Array.isArray(this.value2) ? this.value2 : []
      this.backfillForm = {
        date: currentDate.length === 2 ? [currentDate[0], currentDate[1]] : [],
        gameNames: this.valueGame ? [this.valueGame] : [],
        includeFlowIncome: true,
        includeCashCost: true,
        includeRoi: false,
        includeToufang: true
      }
      this.backfillDialogVisible = true
    },
    submitBackfill() {
      if (!this.backfillForm.date || this.backfillForm.date.length !== 2) {
        this.$message({
          message: '请选择补发日期范围',
          type: 'warning'
        })
        return
      }
      if (!this.backfillForm.includeFlowIncome && !this.backfillForm.includeCashCost && !this.backfillForm.includeRoi && !this.backfillForm.includeToufang) {
        this.$message({
          message: '请至少选择一个补发内容',
          type: 'warning'
        })
        return
      }
      this.backfillLoading = true
      this.$axios
          .post('/juliangData/manual/backfill', {
            startDate: this.backfillForm.date[0],
            endDate: this.backfillForm.date[1],
            gameNames: this.backfillForm.gameNames,
            includeFlowIncome: this.backfillForm.includeFlowIncome,
            includeCashCost: this.backfillForm.includeCashCost,
            includeRoi: this.backfillForm.includeRoi,
            includeToufang: this.backfillForm.includeToufang
          })
          .then(resp => {
            const res = resp.data || {}
            if (res.code === 200) {
              const data = res.data || {}
              this.backfillTask = data
              this.$message({
                message: data.reused ? `已有相同补发任务进行中：${data.taskId}` : `补发任务已提交：${data.taskId}`,
                type: 'success',
                duration: 5000
              })
              if (data.taskId) {
                this.pollBackfillTask(data.taskId)
              }
            } else {
              this.$message({
                message: res.msg || '补发提交失败',
                type: 'warning'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '补发提交失败，请检查登录状态或联系管理员',
              type: 'error'
            })
          })
          .finally(() => {
            this.backfillLoading = false
          })
    },
    pollBackfillTask(taskId) {
      this.clearBackfillTimer()
      const loadTask = () => {
        this.$axios
            .get('/juliangData/manual/backfill/task/' + taskId)
            .then(resp => {
              const res = resp.data || {}
              if (res.code === 200) {
                this.backfillTask = res.data || null
                if (this.backfillTask && (this.backfillTask.status === 'SUCCESS' || this.backfillTask.status === 'FAILED')) {
                  this.clearBackfillTimer()
                }
              } else {
                this.clearBackfillTimer()
              }
            })
            .catch(err => {
              console.log(err)
              this.clearBackfillTimer()
            })
      }
      loadTask()
      this.backfillTaskTimer = window.setInterval(loadTask, 2000)
    },
    clearBackfillTimer() {
      if (this.backfillTaskTimer) {
        window.clearInterval(this.backfillTaskTimer)
        this.backfillTaskTimer = null
      }
    },
    openLiveGameDialog() {
      this.liveGameDialogVisible = true
      if (!this.optionsGame || this.optionsGame.length === 0) {
        this.findGame()
      }
      this.loadLiveGameConfig()
    },
    loadLiveGameConfig() {
      this.liveGameLoading = true
      this.$axios
          .get('/toufang/data/liveGameConfig/find', {})
          .then(resp => {
            const res = resp.data || {}
            if (res.code === 200) {
              this.liveGameList = res.data || []
            } else {
              this.$message({
                message: res.msg || '查询直播游戏配置失败',
                type: 'warning'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message.error('查询直播游戏配置失败')
          })
          .finally(() => {
            this.liveGameLoading = false
          })
    },
    saveLiveGameConfig() {
      if (!this.liveGameForm.gameName) {
        this.$message({
          message: '请选择或输入游戏名',
          type: 'warning'
        })
        return
      }
      this.liveGameSaving = true
      this.$axios
          .post('/toufang/data/liveGameConfig/save', {
            gameName: this.liveGameForm.gameName,
            remark: this.liveGameForm.remark,
            enabled: true
          })
          .then(resp => {
            const res = resp.data || {}
            if (res.code === 200) {
              this.$message.success('直播游戏配置已保存')
              this.liveGameForm = {
                gameName: '',
                remark: ''
              }
              this.loadLiveGameConfig()
            } else {
              this.$message({
                message: res.msg || '保存直播游戏配置失败',
                type: 'warning'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message.error('保存直播游戏配置失败')
          })
          .finally(() => {
            this.liveGameSaving = false
          })
    },
    toggleLiveGame(row, enabled) {
      this.$axios
          .post('/toufang/data/liveGameConfig/save', {
            gameName: row.game_name,
            remark: row.remark || '',
            enabled
          })
          .then(resp => {
            const res = resp.data || {}
            if (res.code === 200) {
              this.$message.success(enabled ? '已启用' : '已停用')
              this.loadLiveGameConfig()
            } else {
              this.$message({
                message: res.msg || '更新直播游戏配置失败',
                type: 'warning'
              })
              this.loadLiveGameConfig()
            }
          })
          .catch(err => {
            console.log(err)
            this.$message.error('更新直播游戏配置失败')
            this.loadLiveGameConfig()
          })
    },
    deleteLiveGameConfig(row) {
      this.$confirm('确认删除直播游戏配置：' + row.game_name + '？', '删除配置', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        this.$axios
            .get('/toufang/data/liveGameConfig/del/' + row.id, {})
            .then(resp => {
              const res = resp.data || {}
              if (res.code === 200) {
                this.$message.success('已删除')
                this.loadLiveGameConfig()
              } else {
                this.$message({
                  message: res.msg || '删除直播游戏配置失败',
                  type: 'warning'
                })
              }
            })
            .catch(err => {
              console.log(err)
              this.$message.error('删除直播游戏配置失败')
            })
      }).catch(() => {
      })
    },
    formatLiveGameTime(row, column, value) {
      if (!value) {
        return '-'
      }
      const text = String(value)
      if (text.indexOf('T') > -1) {
        return text.replace('T', ' ').replace('.000+00:00', '').replace('.000Z', '').slice(0, 19)
      }
      return text.slice(0, 19)
    },
    edit() {

      this.$axios
          .post('/toufang/data/addBi', this.form)
          .then(successResponse => {

            if (successResponse.data.code === 200) {


              this.dialogFormVisible = false

              this.$message({
                message: '操作成功!',
                type: 'success'
              });
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    }, changeGame() {
      this.saveToufangBroadCache();
    },
    indexMethod(index) {

      return index / 6 + 1;

    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。(可能还有边距/边框等值，需要根据实际情况加上)
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },
    createExportData() {

      return this.json_data

    },
    createExportData2() {


      if (!this.json_data2 || this.json_data2.length === 0) {
        return [];
      }

      // 创建数据副本
      return this.json_data2.map(item => {
        return {
          aname: this.checkedCities.indexOf('游戏名') > -1 ? item.aname || '' : null,
          cDate: this.checkedCities.indexOf('日期') > -1 ? item.cDate || '' : null,
          cAmount: item.cAmount ? item.cAmount / 100 : 0,
          r1: item.cAmount && item.bfUv ? (item.cAmount - item.bfUv) / 100 : 0,
          r2: item.cAmount && item.viewCount ? item.cAmount - item.viewCount : 0,
          sumCashCost: item.sumCashCost || 0,
          ygProfit: item.ygProfit || 0,
          r3: item.sum && item.cAmount && item.bfUv ?
              item.sum - item.cAmount / 100 + item.bfUv / 100 : 0
        };
      });

    },

    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    },
    value_format(row, column, value) {
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {
        value = Math.round(value / 100)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return value.toFixed(2)

      } else {

        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format4(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {

        return value
      }
    }, value_format3(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "次日9点更新"
      } else if (isNaN(value)) {

        return '0'

      } else if (value <= 0) {

        return '0'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/toufang/data/findIncomeName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    }, handleClick(tab, event) {

      console.log(tab.name)

    }, handleToufangIncomeError(responseData) {
      if (!responseData || typeof responseData !== 'object') {
        this.$message.error('营收数据返回异常，可能登录状态已失效，请重新登录后再试');
        return true;
      }

      if (responseData.code === 501 || responseData.code === 401) {
        this.$message.error(responseData.msg || responseData.message || '登录状态已失效，请重新登录');
        this.$router.push({
          path: '/login',
          query: {redirect: this.$route.fullPath}
        });
        return true;
      }

      if (responseData.code !== undefined && responseData.code !== 0 && responseData.code !== 200) {
        this.$message.error(responseData.msg || responseData.message || '营收数据查询失败');
        return true;
      }

      if (!Array.isArray(responseData.data)) {
        this.$message.warning('营收数据返回为空，请检查登录状态后重试');
        return true;
      }

      return false;
    }, showToufangIncomeGroupHint() {
      if (this.checkedCities.indexOf('游戏名') > -1) {
        this.incomeGroupHintShown = false;
        return;
      }

      if (!this.incomeGroupHintShown) {
        this.incomeGroupHintShown = true;
        this.$message.info('当前只按日期汇总，勾选“游戏名”后可查看游戏明细。');
      }

    }, groupDataAll(data) {

      let result = {};
      //包含游戏名则不按品类日期汇总
      if (this.checkedYugu.includes("游戏名")) {
        result = data;
      }


      //按品类日期汇总
      // 如果没有数据，直接返回空数组
      if (!data || data.length === 0) {
        return [];
      }
      if (this.checkedYugu.includes("品类")) {
        // 使用 reduce 进行分组和求和
        const grouped = data.reduce((acc, item) => {
          // 获取游戏类型
          const gameType = item.gameTypeConfig && item.gameTypeConfig.gameType
              ? item.gameTypeConfig.gameType
              : '未知类型';
          const uploadDate = item.uploadDate || '未知日期';

          //默认日期分类
          let groupKey = `${uploadDate}`;

          if (this.checkedYugu.includes("品类") && this.checkedYugu.includes("日期")) {
            groupKey = `${gameType}_${uploadDate}`;
          }

          // 如果该类型还没有在累加器中，则初始化
          if (!acc[groupKey]) {
            acc[groupKey] = {
              gameName: (this.checkedYugu.includes("品类") && this.checkedYugu.includes("日期")) ? `${gameType}(合计)` : '-',
              gameTypeConfig: {
                gameType: (this.checkedYugu.includes("品类") && this.checkedYugu.includes("日期")) ? gameType : '-'
              },
              descType: 0,
              uploadDate: uploadDate,
              yuDate: '',
              statCost: 0,
              pfAmount: 0,
              roi0: 0,
              roi1: 0,
              roi2: 0,
              roi3: 0,
              roi4: 0,
              roi5: 0,
              roi6: 0,
              roi7: 0,
              roi15: 0,
              roi30: 0,
              roi45: 0,
              roi60: 0,
              roi75: 0,
              roi90: 0,
              roi105: 0,
              roi120: 0,
              roi135: 0,
              roi150: 0,
              // 用于计算加权平均的权重
              statCostSum: 0,
              count: 0
            };
          }

          // 累加数值字段
          const group = acc[groupKey];
          group.statCost += item.statCost || 0;
          group.pfAmount += item.pfAmount || 0;
          group.descType = item.descType;
          this.markY4Sources(group, item);
          this.markY4DisplaySources(group, item);
          // 累加用于计算加权平均的总消耗
          group.statCostSum += item.statCost || 0;
          group.count += 1;

          // 累加ROI数据（后续需要计算加权平均）
          group.roi0 += (item.roi0 || 0) * (item.statCost || 0);
          group.roi1 += (Math.max(item.roi1) * item.roi0 || 0) * (item.statCost || 0);
          group.roi2 += (Math.max(item.roi2, item.roi1) * item.roi0 || 0) * (item.statCost || 0);
          group.roi3 += (item.roi3 * item.roi0 || 0) * (item.statCost || 0);
          group.roi4 += (item.roi4 * item.roi0 || 0) * (item.statCost || 0);
          group.roi5 += (item.roi5 * item.roi0 || 0) * (item.statCost || 0);
          group.roi6 += (item.roi6 * item.roi0 || 0) * (item.statCost || 0);
          group.roi7 += (item.roi7 * item.roi0 || 0) * (item.statCost || 0);
          group.roi15 += (item.roi15 * item.roi0 || 0) * (item.statCost || 0);
          group.roi30 += (item.roi30 * item.roi0 || 0) * (item.statCost || 0);
          group.roi45 += (item.roi45 * item.roi0 || 0) * (item.statCost || 0);
          group.roi60 += (item.roi60 * item.roi0 || 0) * (item.statCost || 0);
          group.roi75 += (item.roi75 * item.roi0 || 0) * (item.statCost || 0);
          group.roi90 += (item.roi90 * item.roi0 || 0) * (item.statCost || 0);
          group.roi105 += (item.roi105 * item.roi0 || 0) * (item.statCost || 0);
          group.roi120 += (item.roi120 * item.roi0 || 0) * (item.statCost || 0);
          group.roi135 += (item.roi135 * item.roi0 || 0) * (item.statCost || 0);
          group.roi150 += (item.roi150 * item.roi0 || 0) * (item.statCost || 0);

          return acc;
        }, {});

        // 计算加权平均值并转换为数组
        result = Object.values(grouped).map(group => {
          // 只有当总消耗大于0时才计算加权平均
          if (group.statCostSum > 0) {
            group.roi0 = group.roi0 / group.statCostSum;
            group.roi1 = group.roi1 / group.statCostSum / group.roi0;
            group.roi2 = group.roi2 / group.statCostSum / group.roi0;
            group.roi3 = group.roi3 / group.statCostSum / group.roi0;
            group.roi4 = group.roi4 / group.statCostSum / group.roi0;
            group.roi5 = group.roi5 / group.statCostSum / group.roi0;
            group.roi6 = group.roi6 / group.statCostSum / group.roi0;
            group.roi7 = group.roi7 / group.statCostSum / group.roi0;
            group.roi15 = group.roi15 / group.statCostSum / group.roi0;
            group.roi30 = group.roi30 / group.statCostSum / group.roi0;
            group.roi45 = group.roi45 / group.statCostSum / group.roi0;
            group.roi60 = group.roi60 / group.statCostSum / group.roi0;
            group.roi75 = group.roi75 / group.statCostSum / group.roi0;
            group.roi90 = group.roi90 / group.statCostSum / group.roi0;
            group.roi105 = group.roi105 / group.statCostSum / group.roi0;
            group.roi120 = group.roi120 / group.statCostSum / group.roi0;
            group.roi135 = group.roi135 / group.statCostSum / group.roi0;
            group.roi150 = group.roi150 / group.statCostSum / group.roi0;
          }
          this.sanitizeY4RoiGroup(group);

          // 删除临时字段
          delete group.statCostSum;
          delete group.count;

          return group;
        });
      }

      // 添加每个日期的合计行
      // 按日期分组计算合计
      const dateGroups = {};
      data.forEach(item => {
        const date = item.uploadDate;
        if (!dateGroups[date]) {
          dateGroups[date] = {
            gameName: '合计',
            gameTypeConfig: {gameType: '-'},
            uploadDate: date,
            statCost: 0,
            pfAmount: 0,
            roi0: 0,
            roi1: 0,
            roi2: 0,
            roi3: 0,
            roi4: 0,
            roi5: 0,
            roi6: 0,
            roi7: 0,
            roi15: 0,
            roi30: 0,
            roi45: 0,
            roi60: 0,
            roi75: 0,
            roi90: 0,
            roi105: 0,
            roi120: 0,
            roi135: 0,
            roi150: 0,
            statCostSum: 0,
            isDateTotal: true // 标记为日期合计行
          };
        }

        // 累加数据
        const group = dateGroups[date];
        group.statCost += item.statCost || 0;
        group.pfAmount += item.pfAmount || 0;
        group.statCostSum += item.statCost || 0;
        this.markY4Sources(group, item);
        this.markY4DisplaySources(group, item);

        // 累加ROI数据用于加权平均
        group.roi0 += (item.roi0 || 0) * (item.statCost || 0);
        group.roi1 += (item.roi1 * item.roi0 || 0) * (item.statCost || 0);
        group.roi2 += (Math.max(item.roi2, item.roi1) * item.roi0 || 0) * (item.statCost || 0);

        group.roi3 += (Math.max(item.roi3) * item.roi0 || 0) * (item.statCost || 0);
        group.roi4 += (Math.max(item.roi4, item.roi3, item.roi2, item.roi1) * item.roi0 || 0) * (item.statCost || 0);
        group.roi5 += (Math.max(item.roi5, item.roi4, item.roi3, item.roi2, item.roi1) * item.roi0 || 0) * (item.statCost || 0);
        group.roi6 += (Math.max(item.roi6, item.roi5, item.roi4, item.roi3, item.roi2, item.roi1) * item.roi0 || 0) * (item.statCost || 0);
        group.roi7 += (Math.max(item.roi3, item.roi7)  * item.roi0 || 0) * (item.statCost || 0);
        group.roi15 += (Math.max(item.roi3, item.roi7, item.roi15)  * item.roi0 || 0) * (item.statCost || 0);
        group.roi30 += (Math.max(item.roi3, item.roi7, item.roi15, item.roi30)  * item.roi0 || 0) * (item.statCost || 0);
        group.roi45 += (Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45)  * item.roi0 || 0) * (item.statCost || 0);
        group.roi60 += (Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45, item.roi60)  * item.roi0 || 0) * (item.statCost || 0);
        group.roi75 += (Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45, item.roi60, item.roi75)  * item.roi0 || 0) * (item.statCost || 0);
        group.roi90 += (Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45, item.roi60, item.roi75, item.roi90)  * item.roi0 || 0) * (item.statCost || 0);
        group.roi105 += (Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45, item.roi60, item.roi75, item.roi90, item.roi105)  * item.roi0 || 0) * (item.statCost || 0);
        group.roi120 += (Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45, item.roi60, item.roi75, item.roi90, item.roi105, item.roi120) * item.roi0 || 0) * (item.statCost || 0);
        group.roi135 += (Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45, item.roi60, item.roi75, item.roi90, item.roi105, item.roi120, item.roi135)* item.roi0 || 0) * (item.statCost || 0);
        group.roi150 += (Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45, item.roi60, item.roi75, item.roi90, item.roi105, item.roi120, item.roi135, item.roi150)* item.roi0 || 0) * (item.statCost || 0);
      });
      // 计算每个日期的加权平均值
      Object.values(dateGroups).forEach(group => {
        if (group.statCostSum > 0) {
          group.roi0 = group.roi0 / group.statCostSum;
          group.roi1 = group.roi1 / group.statCostSum / group.roi0;
          group.roi2 = group.roi2 / group.statCostSum / group.roi0;
          group.roi3 = group.roi3 / group.statCostSum / group.roi0;
          group.roi4 = group.roi4 / group.statCostSum / group.roi0;
          group.roi5 = group.roi5 / group.statCostSum / group.roi0;
          group.roi6 = group.roi6 / group.statCostSum / group.roi0;
          group.roi7 = group.roi7 / group.statCostSum / group.roi0;
          group.roi15 = group.roi15 / group.statCostSum / group.roi0;
          group.roi30 = group.roi30 / group.statCostSum / group.roi0;
          group.roi45 = group.roi45 / group.statCostSum / group.roi0;
          group.roi60 = group.roi60 / group.statCostSum / group.roi0;
          group.roi75 = group.roi75 / group.statCostSum / group.roi0;
          group.roi90 = group.roi90 / group.statCostSum / group.roi0;
          group.roi105 = group.roi105 / group.statCostSum / group.roi0;
          group.roi120 = group.roi120 / group.statCostSum / group.roi0;
          group.roi135 = group.roi135 / group.statCostSum / group.roi0;
          group.roi150 = group.roi150 / group.statCostSum / group.roi0;
        }
        this.sanitizeY4RoiGroup(group);
        delete group.statCostSum;
      });

      // 将日期合计行和分组数据合并，并按日期排序
      if (this.checkedYugu.includes("游戏名") || this.checkedYugu.includes("品类")) {
        const allData = [...Object.values(dateGroups), ...result];

        // 按日期排序，合计行优先显示
        allData.sort((a, b) => {
          if (a.uploadDate !== b.uploadDate) {
            return a.uploadDate.localeCompare(b.uploadDate);
          }
          // 合计行排在前面
          if (a.isDateTotal) return -1;
          if (b.isDateTotal) return 1;
          return 0;
        });


        return allData;
      }

      return dateGroups;

    },
    groupData(data) {


      //包含游戏名则不按品类日期汇总
      if (this.checkedYugu.includes("游戏名")) {


        return data;
      }



      //按品类日期汇总
      // 如果没有数据，直接返回空数组
      if (!data || data.length === 0) {
        return [];
      }

      // 使用 reduce 进行分组和求和
      const grouped = data.reduce((acc, item) => {
        // 获取游戏类型
        const gameType = item.gameTypeConfig && item.gameTypeConfig.gameType
            ? item.gameTypeConfig.gameType
            : '未知类型';
        const uploadDate = item.uploadDate || '未知日期';

        //默认日期分类
        let groupKey = `${uploadDate}`;

        if (this.checkedYugu.includes("品类") && this.checkedYugu.includes("日期")) {
          groupKey = `${gameType}_${uploadDate}`;

        }

        // 如果该类型还没有在累加器中，则初始化
        if (!acc[groupKey]) {
          acc[groupKey] = {
            gameName: (this.checkedYugu.includes("品类") && this.checkedYugu.includes("日期")) ? `${gameType}(合计)` : '-',
            gameTypeConfig: {
              gameType: (this.checkedYugu.includes("品类") && this.checkedYugu.includes("日期")) ? gameType : '-'
            },
            descType: 0,
            uploadDate: uploadDate,
            yuDate: '',
            statCost: 0,
            pfAmount: 0,
            roi0: 0,
            roi1: 0,
            roi2: 0,
            roi3: 0,
            roi4: 0,
            roi5: 0,
            roi6: 0,
            roi7: 0,
            roi15: 0,
            roi30: 0,
            roi45: 0,
            roi60: 0,
            roi75: 0,
            roi90: 0,
            roi105: 0,
            roi120: 0,
            roi135: 0,
            roi150: 0,
            // 用于计算加权平均的权重
            statCostSum: 0,
            count: 0
          };
        }

        // 累加数值字段
        const group = acc[groupKey];
        group.statCost += item.statCost || 0;
        group.pfAmount += item.pfAmount || 0;
        group.descType = item.descType;
        this.markY4Sources(group, item);
        this.markY4DisplaySources(group, item);
        // 累加用于计算加权平均的总消耗
        group.statCostSum += item.statCost || 0;
        group.count += 1;

        // 累加ROI数据（后续需要计算加权平均）
        group.roi0 += (item.roi0 || 0) * (item.statCost || 0);
        group.roi1 += (Math.max(item.roi1) * item.roi0 || 0) * (item.statCost || 0);
        group.roi2 += (Math.max(item.roi2, item.roi1) * item.roi0 || 0) * (item.statCost || 0);
        group.roi3 += (item.roi3 * item.roi0 || 0) * (item.statCost || 0);
        group.roi4 += (item.roi4 * item.roi0 || 0) * (item.statCost || 0);
        group.roi5 += (item.roi5 * item.roi0 || 0) * (item.statCost || 0);
        group.roi6 += (item.roi6 * item.roi0 || 0) * (item.statCost || 0);
        group.roi7 += (item.roi7 * item.roi0 || 0) * (item.statCost || 0);
        group.roi15 += (item.roi15 * item.roi0 || 0) * (item.statCost || 0);
        group.roi30 += (item.roi30 * item.roi0 || 0) * (item.statCost || 0);
        group.roi45 += (item.roi45 * item.roi0 || 0) * (item.statCost || 0);
        group.roi60 += (item.roi60 * item.roi0 || 0) * (item.statCost || 0);
        group.roi75 += (item.roi75 * item.roi0 || 0) * (item.statCost || 0);
        group.roi90 += (item.roi90 * item.roi0 || 0) * (item.statCost || 0);
        group.roi105 += (item.roi105 * item.roi0 || 0) * (item.statCost || 0);
        group.roi120 += (item.roi120 * item.roi0 || 0) * (item.statCost || 0);
        group.roi135 += (item.roi135 * item.roi0 || 0) * (item.statCost || 0);
        group.roi150 += (item.roi150 * item.roi0 || 0) * (item.statCost || 0);

        return acc;
      }, {});

      // 计算加权平均值并转换为数组
      const result = Object.values(grouped).map(group => {
        // 只有当总消耗大于0时才计算加权平均
        if (group.statCostSum > 0) {
          group.roi0 = group.roi0 / group.statCostSum;
          group.roi1 = group.roi1 / group.statCostSum / group.roi0;
          group.roi2 = group.roi2 / group.statCostSum / group.roi0;
          group.roi3 = group.roi3 / group.statCostSum / group.roi0;
          group.roi4 = group.roi4 / group.statCostSum / group.roi0;
          group.roi5 = group.roi5 / group.statCostSum / group.roi0;
          group.roi6 = group.roi6 / group.statCostSum / group.roi0;
          group.roi7 = group.roi7 / group.statCostSum / group.roi0;
          group.roi15 = group.roi15 / group.statCostSum / group.roi0;
          group.roi30 = group.roi30 / group.statCostSum / group.roi0;
          group.roi45 = group.roi45 / group.statCostSum / group.roi0;
          group.roi60 = group.roi60 / group.statCostSum / group.roi0;
          group.roi75 = group.roi75 / group.statCostSum / group.roi0;
          group.roi90 = group.roi90 / group.statCostSum / group.roi0;
          group.roi105 = group.roi105 / group.statCostSum / group.roi0;
          group.roi120 = group.roi120 / group.statCostSum / group.roi0;
          group.roi135 = group.roi135 / group.statCostSum / group.roi0;
          group.roi150 = group.roi150 / group.statCostSum / group.roi0;
        }
        this.sanitizeY4RoiGroup(group);

        // 删除临时字段
        delete group.statCostSum;
        delete group.count;

        return group;
      });

      return result;
    },
    search(flag) {
      this.ensureY4State()

      if (this.checkedCities.length < 2) {

        this.items = []

      } else {

        this.items = ["7", "15", "30", "45", "60", "75", "90", "105", "120", "135", "150"]
      }

      if (flag) {
        this.saveToufangBroadCache();

      } else {
        this.restoreToufangBroadCache();
      }

      this.ensureY4State()
      this.ensureY4DateRange(false)


      this.maxHeight = window.innerHeight - 250;


      if (this.activeName === '4') {
        this.loading = true
        this.$axios
            .post('/toufang/data/findY4', {
              start: this.value2 == null ? '' : this.value2[0],
              cname: this.valueGame == null ? '' : this.valueGame,
              currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
              end: this.value2 == null ? '' : this.value2[1],
              date: this.value5 == null ? '' : this.value5,
              type: this.yType == null ? '' : this.yType
            })
            .then(successResponse => {


              let filteredData = successResponse.data.data || [];

              // 根据游戏类型过滤数据
              if (this.gameType) {
                filteredData = filteredData.filter(item => {
                  return item.gameTypeConfig && item.gameTypeConfig.gameType === this.gameType;
                });
              }

              //
              if (this.checkedYugu.length === 1 || this.valueGame !== "") {
                filteredData = this.groupData(filteredData)

              } else {
                filteredData = this.groupDataAll(filteredData)

              }

              this.tableDataY4 = filteredData;
// 将 descType 为 2 的数据单独取出
              const descType2Data = this.tableDataY4.filter(e => e.roi2 === 0);
// 处理非 descType 为 2 的数据
              const nonDescType2Data = this.tableDataY4.filter(e => e.roi2 !== 0);
// 对非 descType 为 2 的数据进行处理
              this.tableDataY4 = this.processRoiData(nonDescType2Data);
// 过滤掉 roi0 为 1 的数据
              this.tableDataY4 = this.tableDataY4.filter(function (e) {
                return e.roi0 !== 1
              })

// 将 descType 为 2 的数据重新加入
              this.tableDataY4 = [...this.tableDataY4, ...descType2Data];

              var b = {}

              b.gameName = '合计'
              b.uploadDate = '合计'
              b.statCost = 0
              b.pfAmount = 0
              b.roi0 = 0

              var arr = [1,2, 3,4,5,6 , 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150]

              arr.forEach(function (f) {
                b['roi' + f] = 0
              })


// 过滤掉游戏名称为"合计"的行，只对普通数据进行合计计算，并排除descType为2的数据
              this.tableDataY4.filter(e => e.gameName !== '合计' && e.descType !== 2).forEach(e => {
                e.statCost = e.statCost == null ? 0 : e.statCost
                e.pfAmount = e.pfAmount == null ? 0 : e.pfAmount

                e.roi0 = e.roi0 * e.statCost / (e.statCost - e.pfAmount)
                e.roi0 = isNaN(e.roi0) ? 0 : e.roi0
                this.markY4Sources(b, e)
                this.markY4DisplaySources(b, e)

                b.statCost += e.statCost
                b.pfAmount += e.pfAmount
                b.roi0 += e.roi0 * e.statCost

                // arr.forEach(function (f) {
                //   b['roi' + f] += e['roi' + f] * e.statCost * e['roi0']
                // })

                b.roi0 += (e.roi0 || 0) ;
                b.roi1 += (Math.max(e.roi1) * e.roi0 || 0) * (e.statCost || 0);
                b.roi2 += (Math.max(e.roi2, e.roi1) * e.roi0 || 0) * (e.statCost || 0);
                b.roi3 += (Math.max(e.roi3, e.roi2, e.roi1) * e.roi0 || 0) * (e.statCost || 0);
                b.roi4 += (Math.max(e.roi4, e.roi3, e.roi2, e.roi1)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi5 += (Math.max(e.roi5, e.roi4, e.roi3, e.roi2, e.roi1)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi6 += (Math.max(e.roi6, e.roi5, e.roi4, e.roi3, e.roi2, e.roi1)  * e.roi0 || 0) * (e.statCost || 0);


                b.roi7 += (Math.max(e.roi3, e.roi7)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi15 += (Math.max(e.roi3, e.roi7, e.roi15)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi30 += (Math.max(e.roi3, e.roi7, e.roi15, e.roi30)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi45 += (Math.max(e.roi3, e.roi7, e.roi15, e.roi30, e.roi45)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi60 += (Math.max(e.roi3, e.roi7, e.roi15, e.roi30, e.roi45, e.roi60)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi75 += (Math.max(e.roi3, e.roi7, e.roi15, e.roi30, e.roi45, e.roi60, e.roi75)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi90 += (Math.max(e.roi3, e.roi7, e.roi15, e.roi30, e.roi45, e.roi60, e.roi75, e.roi90)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi105 += (Math.max(e.roi3, e.roi7, e.roi15, e.roi30, e.roi45, e.roi60, e.roi75, e.roi90, e.roi105)  * e.roi0 || 0) * (e.statCost || 0);
                b.roi120 += (Math.max(e.roi3, e.roi7, e.roi15, e.roi30, e.roi45, e.roi60, e.roi75, e.roi90, e.roi105, e.roi120) * e.roi0 || 0) * (e.statCost || 0);
                b.roi135 += (Math.max(e.roi3, e.roi7, e.roi15, e.roi30, e.roi45, e.roi60, e.roi75, e.roi90, e.roi105, e.roi120, e.roi135)* e.roi0 || 0) * (e.statCost || 0);
                b.roi150 += (Math.max(e.roi3, e.roi7, e.roi15, e.roi30, e.roi45, e.roi60, e.roi75, e.roi90, e.roi105, e.roi120, e.roi135, e.roi150)* e.roi0 || 0) * (e.statCost || 0);


              })

              arr.forEach(function (f) {
                b['roi' + f] /= b.roi0
              })

              b.roi0 /= b.statCost - b.pfAmount
              b.roi0 = isNaN(b.roi0) ? 0 : b.roi0


              this.tableDataY4.unshift(b)
              this.tableDataY4 = this.tableDataY4.filter(item => {

                return item.statCost > 0;
              })

              // 数据获取完成后设置默认排序
              this.$nextTick(() => {
                this.customSort({prop: 'uploadDate', order: 'descending'});
                this.tableDataY4CurrentPage = 1;

                if (this.showChart === true) {
                  this.initChart()
                }
              });



              this.loading = false
            })

        this.$axios
            .post('/toufang/data/gameConfig/find', {})
            .then(successResponse => {


              var b = successResponse.data.data

              this.tableDataType = b

            }).catch((err) => {
          //请求失败的回调函数
          console.log(err)
          console.log('失败')
        })

      } else if (this.activeName === '5') {

        this.loading = true
        this.$axios
            .post('/toufang/data/findAllByPerson', {
              start: this.value2 == null ? '' : this.value2[0],
              cname: this.valueGame == null ? '' : this.valueGame,
              currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
              end: this.value2 == null ? '' : this.value2[1],
              param: "",
              author: this.valuePerson == null ? '' : this.valuePerson,
              day: this.valueDay
            })
            .then(successResponse => {


              this.tableData5 = successResponse.data.data


              this.tableData5.forEach(function (e) {

                e.cAmount = parseFloat(e[1])
                //预估90日收入
                e.value1 = (e[20] * (e[21] * e[25] / 100 * e[23] / 100)) === 0 ? e[20] * e[3] : e[20] * (e[21] * e[25] / 100 * e[23] / 100)


                //实时90日实际收入
                e.value2 = e[24] * e[25] / 100 * e[23] / 100
                //首日实际收入
                e.value3 = e[21] * e[25] / 100 * e[23] / 100


              })
              console.log(this.tableData5)
              if (this.checkedCities.length < 2 && this.checkedCities.indexOf('日期') > -1) {

                const grouped = this.tableData5.reduce((acc, item) => {
                  const key = item[2];
                  if (!acc[key]) {
                    acc[key] = {
                      2: key,
                      value1: 0,
                      value2: 0,
                      value3: 0,
                      1: 0,
                      3: 0,
                      4: 0,
                      5: 0,
                      6: 0,
                      9: 0,
                      10: 0,
                      11: 0,
                      12: 0,
                      13: 0,
                      14: 0,
                      19: 0,
                      20: 0,
                      21: 0,
                      23: 0,
                      24: 0,
                      25: 0,
                      cAmount: 0,
                      8: 0
                    };
                  }
                  acc[key].value1 += item.value1;
                  acc[key].value2 += item.value2;
                  acc[key].value3 += item.value3;
                  acc[key][1] += item[1];
                  acc[key][3] += item[3];
                  acc[key][4] += item[4];
                  acc[key][5] += item[5];
                  acc[key][6] += item[6];
                  acc[key][8] += item[8];
                  acc[key][10] += item[10];
                  acc[key][11] += item[11];
                  acc[key][12] += item[12];
                  acc[key][13] += item[13];
                  acc[key][14] += item[14];
                  acc[key][19] += item[19];
                  acc[key][20] = '-';
                  acc[key][21] += item[21];
                  acc[key][23] += item[23];
                  acc[key][24] += item[24];
                  acc[key][25] += item[25];
                  acc[key].cAmount += item.cAmount
                  acc[key][22] = this.valuePerson === '' ? '-' : this.valuePerson

                  return acc;
                }, {});

                console.log(Object.values(grouped))

                this.tableData5 = Object.values(grouped)
              } else if (this.checkedCities.length < 2 && this.checkedCities.indexOf('游戏名') > -1) {


                const grouped = this.tableData5.reduce((acc, item) => {
                  const key = item[0];
                  if (!acc[key]) {
                    acc[key] = {
                      0: key,
                      value1: 0,
                      value2: 0,
                      value3: 0,
                      1: 0,
                      3: 0,
                      4: 0,
                      5: 0,
                      6: 0,
                      9: 0,
                      10: 0,
                      11: 0,
                      12: 0,
                      13: 0,
                      14: 0,
                      19: 0,
                      20: 0,
                      21: 0,
                      23: 0,
                      24: 0,
                      25: 0,
                      cAmount: 0,
                      8: 0
                    };
                  }
                  acc[key].value1 += item.value1;
                  acc[key].value2 += item.value2;
                  acc[key].value3 += item.value3;
                  acc[key][1] += item[1];
                  acc[key][3] += item[3];
                  acc[key][4] += item[4];
                  acc[key][5] += item[5];
                  acc[key][6] += item[6];
                  acc[key][8] += item[8];
                  acc[key][9] += item[9];
                  acc[key][10] += item[10];
                  acc[key][11] += item[11];
                  acc[key][12] += item[12];
                  acc[key][13] += item[13];
                  acc[key][14] += item[14];
                  acc[key][19] += item[19];
                  acc[key][20] = '-';
                  acc[key][21] += item[21];
                  acc[key][23] += item[23];
                  acc[key][24] += item[24];
                  acc[key][25] += item[25];
                  acc[key].cAmount += item.cAmount
                  acc[key][22] = this.valuePerson === '' ? '-' : this.valuePerson

                  return acc;
                }, {});

                console.log(Object.values(grouped))

                this.tableData5 = Object.values(grouped)

              }


              this.optionsPerson = successResponse.data.author

              this.loading = false
            })

        //营收
      } else if (this.activeName === 'third') {
        this.tableData = []
        this.loading = true
        this.$axios
            .post('/toufang/data/findSumYinShou', {
              start: this.value2 == null ? '' : this.value2[0],
              cname: this.valueGame == null ? '' : this.valueGame,
              currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
              end: this.value2 == null ? '' : this.value2[1],
              pf: [1],
              pingtai: [1],
              valueList: [],
              param: this.checkedCities,//分组项
            })
            .then(successResponse => {

              this.loading = false
              const responseData = successResponse.data || {}
              if (this.handleToufangIncomeError(responseData)) {
                return
              }
              const incomeRows = Array.isArray(responseData.data) ? responseData.data : []
              this.showToufangIncomeGroupHint()

              var a = {}

              a['c_date'] = '合 计'
              a['c_name'] = '合 计'
              a['isIncomeSummary'] = true
              a['sum'] = 0
              a['profit'] = 0

              a['bfUv'] = 0
              a['f1'] = 0

              a['f2'] = 0

              a['f3'] = 0
              a['mini_game_bf_purchase_uv'] = 0

              a['mini_game_bf_uv'] = 0

              a['f5'] = 0
              a['f6'] = 0
              a['c_amount'] = 0
              a['sum_cost_cash'] = 0

              a['jlzc'] = 0
              a['f8'] = 0
              a['view_count'] = 0
              incomeRows.forEach(function (e) {

                a['sum'] = ((e.sum == null) ? 0 : parseFloat(e.sum)) + a['sum']


                a['f1'] = a['f1'] + ((e.f1 == null) ? 0 : parseFloat(e.f1))

                a['f2'] = a['f2'] + ((e.f2 == null) ? 0 : parseFloat(e.f2))

                a['f3'] = a['f3'] + ((e.f3 == null) ? 0 : parseFloat(e.f3))  //返点

                a['mini_game_bf_purchase_uv'] = a['mini_game_bf_purchase_uv'] + ((e.mini_game_bf_purchase_uv == null) ? 0 : parseFloat(e.mini_game_bf_purchase_uv))//实际赔付

                a['mini_game_bf_uv'] = a['mini_game_bf_uv'] + ((e.mini_game_bf_uv == null) ? 0 : parseFloat(e.mini_game_bf_uv))

                a['f5'] = a['f5'] + ((e.f5 == null) ? 0 : parseFloat(e.f5)) //激励政策


                a['f6'] = a['f6'] + ((e.f6 == null) ? 0 : parseFloat(e.f6)) //平台赔付

                e['c_amount'] = e.c_amount == null ? 0 : e.c_amount

                a['c_amount'] = a['c_amount'] + e['c_amount']

                e['sum_cost_cash'] = e.sum_cost_cash == null ? 0 : e.sum_cost_cash

                a['sum_cost_cash'] = a['sum_cost_cash'] + parseFloat(e['sum_cost_cash'])

                e['f1'] = e.f1 == null ? 0 : e.f1

                e['f2'] = e.f2 == null ? 0 : e.f2

                e['f3'] = e.f3 == null ? 0 : e.f3

                e['f8'] = e.f8 == null ? 0 : e.f8

                e['av_income'] = e.av_income == null ? 0 : e.av_income

                e['f5'] = e.f5 == null ? 0 : e.f5

                e['jlzc'] = e['av_income'] - e['f5']

                a['jlzc'] = a['jlzc'] + e['jlzc']

                e['f6'] = e.f6 == null ? 0 : e.f6

                e['profit'] = -(e.c_amount / 100 - e.f1 - e.f2 - e.f8 - e.f3 - (e.av_income - e.f5) - e.f6)

                a['profit'] = a['profit'] + e['profit']

                a['view_count'] = a['view_count'] + ((e.view_count == null) ? 0 : parseFloat(e.view_count))

                a['f8'] = a['f8'] + ((e.f8 == null) ? 0 : parseFloat(e.f8))

              })

              this.incomeCurrentPage = 1
              this.tableData.push(a)
              this.tableData = this.tableData.concat(incomeRows)

              this.tableData.forEach(function (e) {

                e.c_amount = parseFloat(e.c_amount / 100 == null ? 0 : e.c_amount / 100)

              })

              this.json_data = this.tableData
              this.refreshIncomeTableLayout()

            })
            .catch(error => {
              this.loading = false
              const responseData = error.response && error.response.data ? error.response.data : {}
              this.$message.error(responseData.msg || responseData.message || error.message || '营收数据查询失败，请刷新或重新登录后再试')
            })


      } else {

        if (this.value2 != null && this.value2 !== '') {

          this.tableData = []
          this.loading = true
          this.$axios
              .post('/toufang/data/findSumAll', {
                start: this.value2 == null ? '' : this.value2[0],
                cname: this.valueGame == null ? '' : this.valueGame,
                currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
                end: this.value2 == null ? '' : this.value2[1],
                pf: [1],
                pingtai: [1],
                valueList: [],
                param: this.checkedCities,//分组项

              })
              .then(successResponse => {

                var a = successResponse.data.total

                a['cDate'] = '合 计'
                a['sum'] = 0
                a['profit'] = 0
                var data = {}
                var data2 = {}
                data['day0'] = 0
                data['day2'] = 0
                data['day6'] = 0
                data['day14'] = 0
                data['day29'] = 0
                data['day59'] = 0
                data['day89'] = 0
                a['bfUv'] = 0
                a['flow_income'] = 0
                a['ad_income'] = 0
                a['fd_income'] = 0
                a['fl_income'] = 0
                a['av_income'] = 0
                a['jl_zc'] = 0
                a['pt_pf'] = 0
                a['ygProfit'] = 0
                a['f8'] = 0
                successResponse.data.data.forEach(function (e) {

                  a['sum'] = e.sum + a['sum']
                  if (e.gold != null) {

                    a['gold'] = ((e.gold == null) ? 0 : parseFloat(e.gold))
                  }

                  a['bfUv'] = a['bfUv'] + ((e.bfUv == null) ? 0 : parseFloat(e.bfUv))

                  a['flow_income'] = a['flow_income'] + ((e.flow_income == null) ? 0 : parseFloat(e.flow_income))
                  a['ad_income'] = a['ad_income'] + ((e.ad_income == null) ? 0 : parseFloat(e.ad_income))
                  a['fd_income'] = a['fd_income'] + ((e.fd_income == null) ? 0 : parseFloat(e.fd_income))  //返点
                  a['fl_income'] = a['fl_income'] + ((e.fl_income == null) ? 0 : parseFloat(e.fl_income))
                  a['av_income'] = a['av_income'] + ((e.av_income == null) ? 0 : parseFloat(e.av_income))
                  a['jl_zc'] = a['jl_zc'] + ((e.jl_zc == null) ? 0 : parseFloat(e.jl_zc)) //激励政策
                  a['pt_pf'] = a['pt_pf'] + ((e.pt_pf == null) ? 0 : parseFloat(e.pt_pf)) //平台赔付
                  //消耗   -  流量主收入   -广告金  -真实赔付                 -框返-返点                          - 激励政策        -平台赔付
                  e['profit'] = -(+e.cAmount / 100 - e.flow_income - e.ad_income - e.bfUv / 100 - e.fl_income - e.fd_income - (e.av_income - (e.jl_zc == null ? 0 : e.jl_zc)) - e.pt_pf)

                  e['ygProfit'] = (e.sumBL * e.data6.day0 + e.viewCount / 100) - e.cAmount / 100

                  a['ygProfit'] = (isNaN(e['ygProfit']) ? 0 : e['ygProfit']) + a['ygProfit']

                  a['profit'] = a['profit'] + e['profit']

                  a['viewCount'] = a['viewCount'] + ((e.viewCount == null) ? 0 : parseFloat(e.viewCount))

                  a['f8'] = a['f8'] + ((e.f8 == null) ? 0 : parseFloat(e.f8))

                  data['day0'] = parseFloat(data['day0']) + parseFloat(e['data6']['day0'])
                  data['day2'] = parseFloat(data['day2']) + parseFloat(e['data6']['day2'])
                  data['day6'] = parseFloat(data['day6']) + parseFloat(e['data6']['day6'])
                  data['day14'] = parseFloat(data['day14']) + parseFloat(e['data6']['day14'])
                  data['day29'] = parseFloat(data['day29']) + parseFloat(e['data6']['day29'])
                  data['day59'] = parseFloat(data['day59']) + parseFloat(e['data6']['day59'])
                  data['day89'] = parseFloat(data['day89']) + parseFloat(e['data6']['day89'])

                })

                a['data6'] = data
                data2['day0'] = (a['data6'].day0 / a['cAmount'] * 10000).toFixed(2)
                data2['day2'] = (a['data6'].day2 / a['cAmount'] * 10000).toFixed(2)
                data2['day6'] = (a['data6'].day6 / a['cAmount'] * 10000).toFixed(2)
                data2['day14'] = (a['data6'].day14 / a['cAmount'] * 10000).toFixed(2)
                data2['day29'] = (a['data6'].day29 / a['cAmount'] * 10000).toFixed(2)
                data2['day59'] = (a['data6'].day59 / a['cAmount'] * 10000).toFixed(2)
                data2['day89'] = (a['data6'].day89 / a['cAmount'] * 10000).toFixed(2)
                a['data'] = data2


                this.tableData.push(a)
                this.tableData = this.tableData.concat(successResponse.data.data)
                console.log(a)

                this.tableData.forEach(function (e) {

                  e.cAmount = parseFloat(e.cAmount)

                })
                console.log('成功')
                // this.querySum()

                this.json_data2 = this.tableData

                this.loading = false
              }).catch((err) => {
            //请求失败的回调函数
            console.log(err)
            console.log('失败')
          })
        }
      }
    },

  }
,
updated() {
  
    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })
  
  },
  mounted: function () {
  
    this.height = window.innerHeight;
    this.ensureY4State();
    // 初始化表格高度
    this.handleResize();
    this.findGame()
    this.search(false)
    this.customSort({prop: 'uploadDate', order: 'descending'});
      
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除监听器
    window.removeEventListener('resize', this.handleResize);
    this.clearBackfillTimer()
  }


}
</script>
<style>

.yugu {
  color: #d65055;
  font-weight: 540;

  //font-family: Georgia, 'Times New Roman', serif;
}

.yugu2 {
  color: #3a8ee6;
  //font-family: Georgia, 'Times New Roman', serif;
  font-weight: 500;
}

.y4-real-value {
  color: #303133;
  font-weight: 400;
}

.y4-summary-row td,
.y4-summary-row .cell,
.y4-summary-row span,
.y4-summary-value {
  font-weight: 700 !important;
}
</style>

<style type="text/css">

*::-webkit-scrollbar {
  width: 5px;
  height: 12px;
  background-color: transparent;
}

.table-number {
  //font-family: 'Consolas', monospace;
  font-size: 12px;
  color: #4b4b4f;
  text-align: right;
}

.table-header {
  font-family: '思源黑体', sans-serif;
  font-size: 14px;
}

.updated-marker-icon {
  color: #e39f0b;
  font-size: 14px;
  margin-left: 5px;
  vertical-align: middle;
}

.bbb2 {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px 16px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 98%;
  min-height: 97vh;
  max-height: 98vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

}

.date-total-row {
  background-color: #f0f9eb !important;
  font-weight: bold;
}

.date-total-row .cell {
  color: #67c23a;
}


.bbb1::after {
  content: "";
  display: table;
  clear: both;
}

</style>


<style scoped>
.responsive-container {
  width: 94vw;
  min-width: 1200px;
  transition: all 0.3s ease;
}

.responsive-content {
  padding: 25px 15px;
  box-sizing: border-box;
}

.responsive-header {
  display: flex;
  height: 40px;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.responsive-chart {
  width: 100%;
  height: 50vh;
  min-height: 400px;
  max-height: 600px;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 75px;
}

.material-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 4px;
  transition: transform 0.3s ease;
}

.material-image:hover {
  transform: scale(1.05);
}

.preview-image {
  width: 100%;
  height: auto;
  max-height: 70vh;
  object-fit: contain;
}
.drag-container {
  display: flex;
  align-items: center;
}

.drag-item {
  display: inline-block;
}

.flip-list-move {
  transition: transform 0.3s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.flip-list-enter-active, .flip-list-leave-active {
  transition: all 0.3s;
}

.flip-list-enter, .flip-list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.red {

  color: #d65055;

}

.green {

  color: #5daf34;
}

/* Vue2 语法 */
.chart-container {
  padding: 20px 10px;
  width: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.el-select2 {
  margin-bottom: 20px;
  width: 100%;
}

/deep/ .el-tabs__item {
  font-size: 15px; /* 字体大小 */
  font-family: '思源黑体', sans-serif; /* 字体类型 */
  color: #565454; /* 默认颜色 */
  font-weight: bold; /* 字重 */
}

/* Vue2 兼容写法 */
::v-deep .el-tabs__nav {
  font-weight: bold;
}

/* 移除 Tabs 内容区的多余高度 */
::v-deep .el-tabs__content {
  overflow: visible;
  height: auto;
}

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.96);

}

/deep/ .el-range-input {
  background-color: rgba(248, 245, 245, 0.94);

}

.backfill-tip {
  margin-left: 110px;
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}

.backfill-status {
  margin: 12px 0 0 110px;
}

.backfill-status-body {
  line-height: 22px;
  font-size: 12px;
}

.backfill-error-title {
  margin-top: 6px;
  color: #e6a23c;
}

.backfill-error-line {
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.y4-pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #fff;
}

.y4-pagination-top {
  margin-top: 8px;
  margin-bottom: 6px;
  padding: 4px 0;
}
</style>
